import type { Dictionary } from './en';

/** القاموس العربي: يطابق شكل القاموس الإنجليزي حرفيًا (يتحقق منه TypeScript). */
export const ar: Dictionary = {
  app: {
    name: 'cTax',
    pageTitle: (page: string) => `${page} · cTax`,
    skipToContent: 'الانتقال إلى المحتوى الرئيسي',
    homeLabel: 'الصفحة الرئيسية لـ cTax',
  },
  nav: {
    label: 'مراكز العمل',
    today: 'اليوم',
    billing: 'الفوترة',
    incoming: 'الوارد',
    filing: 'الإقرارات',
    records: 'السجلات',
    organization: 'المنشأة',
    hubPages: (hub: string) => `صفحات ${hub}`,
    notBuiltTag: 'لم تُبنَ بعد',
  },
  modules: {
    billingDocuments: {
      name: 'مستندات الفوترة',
      line1:
        'أنشئ مسودات الفواتير وأصدرها وأرسلها إلى مصلحة الضرائب، ثم تابع كل فاتورة حتى حالتها النهائية.',
      line2: 'يشمل ذلك النسخ والطباعة بصيغة PDF.',
    },
    receipts: {
      name: 'الإيصالات الإلكترونية',
      line1: 'أصدر إيصالات إلكترونية من جهاز نقطة بيع مسجّل.',
      line2: 'لكل جهاز نقطة بيع ترقيمه وبيانات ربطه الخاصة.',
    },
    paymentTracking: {
      name: 'متابعة السداد',
      line1: 'سجّل ما دفعه المشترون وطابقه مع مستنداتهم.',
      line2: 'سجل داخلي فقط: لا تتحرك أي أموال.',
    },
    receivedDocuments: {
      name: 'المستندات الواردة',
      line1: 'اطّلع على المستندات التي أصدرها الموردون لمنشأتك على منظومة المصلحة.',
      line2: 'راجع كل مستند واقبله أو ارفضه خلال المهلة المسموح بها.',
    },
    filing: {
      name: 'نظرة على الفترة',
      line1:
        'ضريبة القيمة المضافة للشهر والخصم تحت حساب الضريبة للربع، مجمّعة حسب الالتزام ومع رابط إلى كل كشف.',
      line2: 'الأرقام من المستندات الصادرة من النظام فقط، وهي للمراجعة وليست إقرارًا مقدَّمًا.',
    },
    filingSales: {
      name: 'مبيعات الفترة',
      line1: 'كل مستندات البيع في الأيام التي تختارها، بقيمها وضرائبها ومجاميعها لكل الصفحات.',
      line2: 'تختار حساب المستندات بتاريخ المستند أو بتاريخ استلام المصلحة لها.',
    },
    filingPurchases: {
      name: 'مشتريات الفترة',
      line1: 'المستندات التي أصدرها الموردون لمنشأتك في الأيام التي تختارها، بقيمها وضرائبها.',
      line2: 'تُبنى مع صفحة المستندات الواردة، لأنها تقرأ منها.',
    },
    filingVat: {
      name: 'ورقة عمل ضريبة القيمة المضافة',
      line1: 'جانب المخرجات وجانب المدخلات ونتيجة الفترة، وكل رقم يفتح المستندات التي وراءه.',
      line2: 'تصنيف الأرقام تحت الدراسة الضريبية، ولا يظهر قبل اعتماده.',
    },
    filingWithholding: {
      name: 'كشف الخصم تحت حساب الضريبة',
      line1: 'بنود الخصم تحت حساب الضريبة (T4) في المستندات، لكل طرف مقابل وفي كل ربع.',
      line2: 'يُبنى مع صفحة المستندات الواردة، ومعالجته تحت الدراسة الضريبية.',
    },
    filingFiles: {
      name: 'الملفات المجهّزة',
      line1: 'جهّز ملفًا من أي كشف في الخلفية، ثم احفظه من هنا حين يكتمل.',
      line2: 'يبقى كل ملف متاحًا مدة محددة تُذكر بجانبه.',
    },
    buyers: {
      name: 'سجل المشترين',
      line1: 'كل المشترين في مكان واحد: بياناتهم وعناوينهم وأرصدتهم.',
      line2: 'إلى أن تكتمل، أضف المشتري من داخل الفاتورة.',
    },
    suppliers: {
      name: 'سجل الموردين',
      line1: 'بيانات الموردين وما يستحق لكل منهم.',
      line2: 'تُبنى مع صفحة المستندات الواردة.',
    },
    items: {
      name: 'كتالوج الأصناف',
      line1: 'سلعك وخدماتك بأكوادها لدى المصلحة وضرائبها الافتراضية.',
      line2: 'إلى أن تكتمل، أضف الصنف من داخل الفاتورة.',
    },
    orgSetup: {
      name: 'إعداد المنشأة',
      line1: 'بيانات المنشأة وفروعها وضرائبها وترقيم مستنداتها وربطها بالمصلحة.',
      line2: 'خطوات التجهيز الأساسية متاحة الآن من صفحة «اليوم».',
    },
    team: {
      name: 'الفريق والصلاحيات',
      line1: 'ادعُ زملاءك وحدّد ما يستطيع كل منهم فعله في كل منشأة.',
      line2: 'الصلاحيات مطبّقة على الخادم من الآن.',
    },
    imports: {
      name: 'رفع البيانات من ملف',
      line1: 'انقل المشترين والموردين والأصناف والفواتير من ملفات مجهّزة.',
      line2: 'تُعرض كل الأخطاء قبل حفظ أي شيء.',
    },
    notes: {
      name: 'الإشعارات الدائنة والمدينة',
      line1: 'لا يُصدَر إشعار إلا بالرجوع إلى فواتير صالحة لدى المصلحة.',
      line2: 'لا يتجاوز الإشعار ما تسمح به الفاتورة المرجعية.',
    },
  },
  notBuilt: {
    chip: 'لم تُبنَ بعد',
    plannedBlock: (block: string) => `الكتلة المخطَّطة: ${block} من 10`,
    whatItWillDo: 'ما ستقدمه هذه الصفحة',
    goInvoices: 'افتح مستندات الفوترة',
    unknown: 'هذه الصفحة غير موجودة.',
  },
  testEnv: {
    strip: 'بيئة اختبار — لا يصل أي شيء إلى مصلحة الضرائب',
    detail: 'المستندات تذهب إلى محاكٍ، والأسماء والأرقام وهمية. لا تُدخل بيانات ممولين حقيقية.',
    more: 'عن بيئة الاختبار',
  },
  common: {
    optional: 'اختياري',
    loading: 'جارٍ التحميل…',
    searching: 'جارٍ البحث…',
    searchFailed: 'تعذّر البحث. حاول مرة أخرى.',
    noMatches: 'لا توجد نتائج مطابقة',
    clearSelection: 'مسح الاختيار',
    openCalendar: 'فتح التقويم',
    previousMonth: 'الشهر السابق',
    nextMonth: 'الشهر التالي',
    retry: 'حاول مرة أخرى',
    cancel: 'إغلاق دون حفظ',
    notNow: 'ليس الآن',
    dismiss: 'إغلاق',
    copied: 'تم النسخ',
    notSet: 'غير محدد',
  },
  pagination: {
    label: 'التنقل بين الصفحات',
    range: (from: string, to: string, total: string) => `${from}–${to} من ${total}`,
    page: (page: string, pages: string) => `صفحة ${page} من ${pages}`,
    pageSize: 'عدد الصفوف في الصفحة',
    previous: 'الصفحة السابقة',
    next: 'الصفحة التالية',
    first: 'الصفحة الأولى',
    last: 'الصفحة الأخيرة',
  },
  shell: {
    organizations: 'المنشآت',
    chooseOrganization: 'اختر المنشأة',
    orgSwitcherLabel: (name: string | null) =>
      name ? `المنشأة: ${name}. تبديل المنشأة` : 'اختر المنشأة',
    allOrganizations: 'كل المنشآت',
    createOrganization: 'منشأة جديدة',
    current: 'الحالية',
    switchLanguage: 'تغيير اللغة',
    otherLanguageName: 'English',
    accountMenu: 'الحساب',
    theme: 'المظهر',
    themes: { system: 'حسب النظام', light: 'فاتح', dark: 'داكن' },
    signOut: 'تسجيل الخروج',
  },
  palette: {
    open: 'ابحث أو انتقل إلى…',
    title: 'لوحة الأوامر',
    searchLabel: 'البحث في الأوامر',
    placeholder: 'اكتب اسم صفحة أو منشأة أو أمر…',
    empty: 'لا توجد أوامر مطابقة',
    sectionGo: 'انتقل إلى',
    sectionOrganizations: 'المنشآت',
    sectionPreferences: 'اللغة والمظهر',
    switchTo: (name: string) => `التبديل إلى ${name}`,
    switchToArabic: 'التبديل إلى العربية',
    switchToEnglish: 'التبديل إلى الإنجليزية',
    themeLight: 'استخدام المظهر الفاتح',
    themeDark: 'استخدام المظهر الداكن',
    themeSystem: 'استخدام مظهر النظام',
    hintNavigate: 'للتنقل',
    hintRun: 'للفتح',
    hintClose: 'للخروج',
  },
  env: {
    mock: 'بيئة تجريبية',
    preprod: 'ما قبل الإنتاج',
    production: 'بيئة الإنتاج',
  },
  roles: {
    owner: 'مالك',
    admin: 'مدير',
    accountant: 'مسؤول الحسابات',
    sales: 'فريق المبيعات',
    viewer: 'مشاهد',
  },
  auth: {
    brandHeadline: 'الفاتورة الإلكترونية والضرائب والمحاسبة للمنشآت في مصر.',
    brandPoints: [
      'فواتير تُحسب تمامًا كما تتحقق منها مصلحة الضرائب المصرية.',
      'بالعربية والإنجليزية، مع أولوية الاتجاه من اليمين إلى اليسار.',
      'كل تعديل مسجَّل في سجل التدقيق.',
    ],
    signInTitle: 'تسجيل الدخول',
    signInSubtitle: 'مرحبًا بعودتك. سجّل الدخول للمتابعة إلى منشآتك.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    sessionExpired: 'انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.',
    noAccount: 'مستخدم جديد؟',
    createAccount: 'أنشئ حسابًا',
    registerTitle: 'إنشاء حساب',
    registerSubtitle: 'ستُعِد بيانات منشأتك في الخطوة التالية.',
    displayName: 'اسمك',
    passwordHint: '10 أحرف على الأقل، ولا تعتمد على بريدك الإلكتروني.',
    register: 'إنشاء الحساب',
    haveAccount: 'لديك حساب بالفعل؟',
  },
  orgs: {
    eyebrow: 'المنشأة',
    chooseTitle: 'منشآتك',
    chooseSubtitle: 'اختر المنشأة التي تريد العمل عليها.',
    emptyTitle: 'لا توجد منشآت بعد',
    emptyBody: 'أنشئ منشأتك لتبدأ في إصدار الفواتير الإلكترونية.',
    createTitle: 'منشأة جديدة',
    createSubtitle: 'الكيان القانوني الذي يُصدر الفواتير إلى مصلحة الضرائب المصرية.',
    identitySection: 'بيانات المنشأة',
    name: 'اسم المنشأة',
    legalName: 'الاسم القانوني',
    legalNameHint: 'كما هو مسجّل لدى مصلحة الضرائب، إن كان مختلفًا عن الاسم أعلاه.',
    rin: 'رقم التسجيل الضريبي',
    rinHint: '9 أرقام. لازم لإصدار الفواتير، وإلزامي لبيئة الإنتاج.',
    baseCurrency: 'العملة الأساسية',
    environment: 'بيئة الربط مع مصلحة الضرائب',
    environmentIntro: 'الجهة التي ستُرسَل إليها مستندات هذه المنشأة عند تفعيل الإرسال.',
    envDescriptions: {
      mock: 'ربط محاكى لتجربة النظام. لا يصل أي شيء إلى مصلحة الضرائب.',
      preprod: 'منظومة ما قبل الإنتاج لدى مصلحة الضرائب، لاختبار الربط.',
      production: 'منظومة مصلحة الضرائب الفعلية. للمستندات أثر قانوني.',
    },
    environmentLockedTitle: 'يُختار مرة واحدة',
    environmentLocked: 'لا يمكن تغيير البيئة بعد إنشاء المنشأة. استخدم منشأة منفصلة للاختبار.',
    create: 'إنشاء المنشأة',
    created: 'تم إنشاء المنشأة.',
    profileTitle: 'بيانات المنشأة',
  },
  address: {
    country: 'الدولة أو الإقليم',
    governate: 'المحافظة أو الولاية',
    regionCity: 'المدينة / المنطقة',
    street: 'اسم الشارع',
    buildingNumber: 'رقم المبنى',
    more: 'تفاصيل إضافية للعنوان',
    postalCode: 'الرمز البريدي',
    floor: 'الطابق',
    room: 'الغرفة',
    landmark: 'علامة مميزة',
    additionalInformation: 'معلومات إضافية',
  },
  validation: {
    decimalInvalid: 'أدخل رقمًا، مثل 1250.50',
    decimalTooManyDecimals: 'استخدم 5 أرقام عشرية كحد أقصى.',
    decimalTooLarge: 'هذا الرقم كبير جدًا.',
  },
  errors: {
    unknown: 'حدث خطأ ما. حاول مرة أخرى.',
    reference: 'المرجع',
    copyReference: 'نسخ المرجع',
    summaryTitle: (count: number) =>
      count === 1 ? 'صحّح مشكلة واحدة للمتابعة' : `صحّح ${count} مشكلات للمتابعة`,
    issueFallback: 'هذه القيمة غير مقبولة ({issue}).',
    retryInSeconds: 'حاول مرة أخرى بعد {seconds} ثانية.',
    retryInMinutes: 'حاول مرة أخرى بعد {minutes} دقيقة.',
    notFoundTitle: 'الصفحة غير موجودة',
    notFoundBody: 'ربما كُتب العنوان بشكل خاطئ أو نُقلت الصفحة.',
    orgNotFoundTitle: 'المنشأة غير متاحة',
    orgNotFoundBody: 'إما أنها غير موجودة، أو أنك لست عضوًا فيها.',
    goHome: 'الذهاب إلى صفحة البداية',
    codes: {
      validation_error: 'بعض البيانات تحتاج إلى مراجعة.',
      bad_request: 'تعذّر تنفيذ الطلب.',
      unauthenticated: 'انتهت جلستك. يُرجى تسجيل الدخول مرة أخرى.',
      permission_denied: 'ليست لديك صلاحية لتنفيذ هذا الإجراء.',
      not_found: 'هذا السجل غير موجود، أو ليست لديك صلاحية الوصول إليه.',
      document_state_conflict: 'تم إصدار هذا المستند بالفعل ولم يعد قابلًا للتعديل.',
      duplicate_document: 'يوجد سجل آخر بنفس البيانات.',
      version_conflict: 'عدّل مستخدم آخر هذا السجل. أعد تحميله لرؤية أحدث نسخة.',
      idempotency_conflict: 'تم إرسال هذا الطلب من قبل.',
      rate_limited: 'محاولات كثيرة جدًا.',
      eta_auth_failed: 'رفضت مصلحة الضرائب بيانات الربط.',
      eta_submission_failed: 'لم تقبل مصلحة الضرائب الإرسال.',
      eta_unavailable: 'منظومة مصلحة الضرائب غير متاحة حاليًا.',
      import_row_error: 'يوجد خطأ في أحد صفوف الملف المستورد.',
      not_implemented: 'هذا الإجراء غير متاح بعد.',
      buyer_email_missing:
        'لا يوجد بريد فواتير للمشتري، فلم تصدر الفاتورة. أصدِرها بلا نسخة بالبريد، أو أضِف البريد أولًا.',
      buyer_email_invalid:
        'بريد الفواتير للمشتري ليس عنوانًا صالحًا، فلم تصدر الفاتورة. أصدِرها بلا نسخة بالبريد، أو صحّح البريد أولًا.',
      email_not_failed: 'تغيّرت حالة نسخة المشتري، فعرضنا أحدث حالة.',
      eta_window_closed: 'انتهت مهلة هذا الإجراء لدى المصلحة.',
      active_referencing_documents: 'ألغِ أولًا الإشعارات المبنية على هذه الفاتورة.',
      document_frozen: 'جمّدت المصلحة هذا المستند.',
      receiver_actions_mock_only: 'هذا الإجراء متاح في المحاكي فقط حاليًا.',
      internal_error: 'حدث خطأ من جانبنا. حاول مرة أخرى.',
      network_error: 'تعذّر الاتصال بالخادم. تحقّق من اتصالك ثم حاول مرة أخرى.',
      unexpected_response: 'وصل رد غير متوقع من الخادم.',
    },
  },
  issues: {
    reason_required: 'اكتب سبب الإلغاء.',
    reason_too_long: 'السبب أطول من 500 حرف.',
    preview_mock_only: 'تُنشأ المنشآت في هذه النسخة التجريبية ببيئة الاختبار فقط.',
    required: 'حقل مطلوب.',
    too_small: 'حقل مطلوب.',
    too_big: 'النص أطول من المسموح.',
    invalid_type: 'حقل مطلوب.',
    invalid_format: 'الصيغة غير صحيحة.',
    invalid_value: 'اختر إحدى القيم المسموح بها.',
    invalid_union: 'القيمة غير صحيحة.',
    custom: 'القيمة غير صحيحة.',
    unrecognized_keys: 'حقل غير متوقع.',
    invalid_decimal: 'أدخل رقمًا صحيحًا.',
    unavailable: 'لا يمكن التسجيل بهذا البريد الإلكتروني.',
    too_short: 'استخدم 10 أحرف على الأقل.',
    too_long: 'استخدم 128 حرفًا كحد أقصى.',
    contains_email: 'لا تستخدم بريدك الإلكتروني داخل كلمة المرور.',
    unknown: 'غير موجود في جداول الأكواد الرسمية لمصلحة الضرائب.',
    kind_mismatch: 'هذه الضريبة مبلغ ثابت ولا تأخذ نسبة.',
    not_in_list: 'يجب أن يكون الكود الرئيسي أحد الأكواد المختارة.',
    business_requires_9_digit_rin: 'تحتاج المنشأة إلى رقم تسجيل ضريبي من 9 أرقام.',
    person_national_id_14_digits: 'الرقم القومي المصري يتكون من 14 رقمًا.',
    foreign_requires_vat_id: 'يحتاج المشتري الأجنبي إلى رقمه الضريبي في بلده.',
    foreign_must_not_be_eg: 'يجب أن يكون عنوان المشتري الأجنبي خارج مصر.',
    business_in_egypt_must_be_eg: 'يجب أن يكون عنوان المشتري (منشأة) داخل مصر.',
    duplicate: 'مستخدم بالفعل في سجل آخر.',
    goods_only: 'يمكن تتبع المخزون للسلع فقط.',
    unknown_party: 'هذا المشتري لم يعد موجودًا.',
    not_a_customer: 'هذا الطرف غير مُعرّف كمشترٍ.',
    unknown_item: 'هذا الصنف لم يعد موجودًا أو تمت أرشفته.',
    item_without_eta_code: 'هذا الصنف ليس له كود صنف لدى مصلحة الضرائب.',
    unknown_or_inactive_tax: 'هذه الضريبة غير معروفة أو غير مفعّلة.',
    required_for_foreign_currency: 'سعر التحويل إلى الجنيه مطلوب عند استخدام عملة أجنبية.',
    issuer_requires_rin: 'أضف رقم التسجيل الضريبي لمنشأتك قبل إصدار المستندات.',
    unknown_branch: 'هذا الفرع لم يعد موجودًا أو غير مفعّل.',
    not_registered_for_organization: 'رمز النشاط هذا غير مسجّل لمنشأتك.',
    receiver_requires_tax_id: 'يحتاج هذا المشتري إلى رقم ضريبي قبل إصدار فاتورة له.',
    receiver_requires_address: 'يحتاج هذا المشتري إلى عنوان قبل إصدار فاتورة له.',
    in_future: 'لا يمكن أن يكون تاريخ المستند في المستقبل.',
    before_issue_date: 'لا يمكن أن يسبق موعد السداد تاريخ المستند.',
    missing_series: 'لا توجد سلسلة ترقيم مُعدّة لهذا النوع من المستندات.',
    invalid: 'تعذّرت قراءة المسودة المحفوظة. أنشئ المستند من جديد.',
    must_be_positive: 'يجب أن تكون القيمة أكبر من صفر.',
    must_be_non_negative: 'لا يمكن أن تكون القيمة سالبة.',
    out_of_range: 'يجب أن تكون القيمة بين {min} و{max}.',
    exceeds_sales_total: 'لا يمكن أن يزيد الخصم على إجمالي مبيعات البند.',
    exceeds_document_total: 'لا يمكن أن يزيد الخصم الإضافي على إجمالي المستند.',
    invalid_currency: 'كود عملة غير معروف.',
    must_be_empty_for_egp: 'لا يُستخدم في المستندات بالجنيه المصري.',
    unknown_tax_type: 'نوع ضريبة غير معروف.',
    duplicate_tax_type: 'نوع الضريبة نفسه مطبّق مرتين على هذا البند.',
    unknown_subtype: 'نوع فرعي غير معروف للضريبة.',
    subtype_parent_mismatch: 'هذا النوع الفرعي يتبع نوع الضريبة {expected}.',
    must_be_zero_for_fixed_amount: 'الضرائب ذات المبلغ الثابت تأخذ مبلغًا وليس نسبة.',
    computed_field: 'تُحسب هذه القيمة تلقائيًا.',
    required_in_document_currency: 'أدخل سعر الوحدة بعملة المستند (سعر الكتالوج بالجنيه المصري).',
    receiver_same_as_issuer: 'لا يمكن أن يكون المشتري هو منشأتك نفسها.',
    export_requires_foreign_receiver: 'فاتورة التصدير تحتاج مشتريًا أجنبيًا.',
    export_receiver_country_is_eg: 'يجب أن يكون عنوان مشتري التصدير خارج مصر.',
    required_for_export: 'مطلوب في فواتير التصدير.',
    unknown_weight_unit: 'اختر وحدة وزن من جدول المصلحة.',
    currency_not_enabled: 'فعّل هذه العملة لمنشأتك أولًا.',
    past_date: 'تاريخ المستند في الماضي. تأكد أن هذا مقصود.',
    cash_customer_unpublished_threshold:
      'مشترٍ بلا رقم تعريف: تقبله مصلحة الضرائب تحت حد لا تعلنه.',
    kg_is_keg: 'الوحدة "KG" في جدول المصلحة تعني برميلًا صغيرًا؛ الكيلوجرام هو "KGM".',
    tax_not_mapped: 'الضريبة {taxType}/{subType} لم تعد مُعدّة، لذلك لم تُنسخ.',
    tax_rate_changed: 'تغيّرت نسبة الضريبة {taxType} من {from}٪ إلى {to}٪.',
    immutable: 'لا يمكن تغيير هذا بعد الحفظ.',
    unknown_code: 'غير موجود في جدول الأكواد الرسمي.',
    not_allowed_for_type: 'غير مسموح لهذا النوع من الإيصالات.',
    not_64_hex: 'يجب أن يكون معرّفًا من 64 حرفًا.',
    not_iso_4217: 'كود عملة غير صالح.',
    not_9_digits: 'يجب أن يكون 9 أرقام.',
    not_14_digits: 'يجب أن يكون 14 رقمًا.',
    equals_seller_rin: 'لا يمكن أن يكون رقم المشتري هو رقم التسجيل الضريبي لمنشأتك.',
    business_buyer_restricted: 'المشترون من المنشآت غير مسموح بهم لهذه المنشأة.',
    required_above_threshold: 'مطلوب لأن الإجمالي يبلغ حد الإفصاح.',
    not_5dp: 'استخدم 5 أرقام عشرية كحد أقصى.',
    must_differ_from_uuid: 'يجب أن يختلف عن معرّف الإيصال نفسه.',
    too_many_lines: 'يحتوي الإيصال على {max} بندًا كحد أقصى.',
    too_few_receipts: 'يحتاج الإرسال إلى إيصال واحد على الأقل ({min}).',
    unknown_pos_device: 'جهاز نقطة البيع هذا غير موجود أو غير مفعّل.',
    branch_mismatch: 'جهاز نقطة البيع هذا لا يتبع فرع الإصدار المختار.',
    required_with_amount_filter: 'حدد العملة مع حد المبلغ؛ لا تُقارن مبالغ عملات مختلفة.',
    // رفض ما لا يصحّ عند تحرير إشعار، وتنبيهاته (الكتلة 11، WP-11.4؛ sales-notes.md §7).
    unknown_document: 'لا يوجد مستند بهذا الرقم في منشأتك.',
    not_an_invoice: 'هذا المستند ليس فاتورة من عائلة هذا الإشعار.',
    not_issued: 'الفاتورة المرجعية مسودة أو محذوفة أو مستبدلة.',
    not_valid_at_eta: 'لم تُثبت مصلحة الضرائب صلاحية الفاتورة المرجعية.',
    cancellation_pending: 'الفاتورة المرجعية بانتظار تأكيد إلغائها لدى المصلحة.',
    issued_after_note: 'الفاتورة المرجعية أحدث من الإشعار.',
    same_day_as_note: 'صدرت الفاتورة المرجعية في اليوم نفسه للإشعار.',
    cancel_window_open: 'ما زال بالإمكان طلب إلغاء الفاتورة المرجعية بدلًا من ذلك.',
    other_receiver: 'الفاتورة المرجعية تخص مشتريًا آخر.',
    mixed_activity_code: 'المراجع تختلف في رمز نشاط المموّل.',
    mixed_branch: 'المراجع تختلف في فرع الإصدار.',
    mixed_currency: 'المراجع تختلف في عملة المستند.',
    single_for_unidentified_buyer: 'المشتري بلا بيانات لا يسمح إلا بمرجع واحد.',
    note_family_mismatch: 'لا يطابق المرجع عائلة هذا الإشعار.',
    not_in_references: 'هذا البند لا يأتي من أي فاتورة مرجعية.',
    locked_to_reference: 'هذا الحقل مأخوذ من الفاتورة المرجعية ولا يمكن تغييره.',
    exceeds_reference:
      'يتجاوز هذا الإشعار ما يمكن تخفيضه: المتبقي {remaining} ج.م من {cap} ج.م، بعد إشعارات دائن أخرى بقيمة {otherCredits} ج.م.',
    differs_from_reference: 'يختلف سعر التحويل عن سعر الفاتورة المرجعية.',
  },
  docStatus: {
    draft: 'مسودة',
    issued: 'تم إصدارها',
    signing: 'جاري الختم الإلكتروني',
    signed: 'تم الختم الإلكتروني',
    superseded: 'مستبدلة',
    discarded: 'مسودة محذوفة',
  },
  taxStatus: {
    incomplete: 'غير مكتملة',
    ready: 'جاهزة للإصدار',
    signing: 'جاري الختم الإلكتروني',
    signed: 'تم الختم الإلكتروني',
    not_submitted: 'لم تُرسل للمصلحة',
    submitting: 'في الطريق إلى المصلحة',
    submitted: 'بانتظار تحقق المصلحة',
    valid: 'صالحة',
    invalid: 'غير صالحة',
    rejected: 'مرفوضة من المستلم',
    not_accepted: 'لم تُقبل عند الإرسال',
    cancelled: 'ملغاة لدى المصلحة',
  },
  mock: {
    label: 'محاكاة',
    title: 'بيئة تجريبية: لا يُرسل أي شيء إلى مصلحة الضرائب',
    scenario: 'رد المصلحة التجريبي',
    scenarioHint: 'للاختبار فقط: كيف ترد المصلحة التجريبية عند إرسال هذه المسودة.',
    scenarios: {
      valid: 'صالحة',
      invalid: 'غير صالحة',
      not_accepted: 'لا تُقبل عند الإرسال',
      rejected: 'صالحة ثم يرفضها المستلم',
      cancelled: 'صالحة ثم تُلغى',
      retry_wait: 'انشغال ثم إعادة محاولة',
      unknown: 'ضياع الرد ثم المطابقة',
    },
  },
  sales: {
    eyebrow: 'الفوترة',
    title: 'مستندات الفوترة',
    newMenu: 'ابدأ مستندًا',
    newInvoice: 'ابدأ فاتورة',
    newExportInvoice: 'ابدأ فاتورة تصدير',
    startCredit: 'ابدأ إشعار الدائن',
    startDebit: 'ابدأ إشعار المدين',
    tabs: {
      invoices: 'الفواتير وفواتير التصدير',
      credit: 'إشعارات الدائن',
      debit: 'إشعارات المدين',
    },
    tabsLabel: 'فئة المستند',
    emptyTitle: 'لا توجد فواتير بعد',
    emptyBody: 'أنشئ فاتورتك الأولى؛ تحصل على رقمها بمجرد حفظها.',
    noteEmpty: 'يبدأ الإشعار من فاتورة صالحة لنفس المشتري.',
    noResultsTitle: 'لا توجد نتائج مطابقة',
    noResultsBody: 'جرّب بحثًا آخر، أو امسح عوامل التصفية.',
    search: 'البحث في المستندات',
    searchPlaceholder: 'الرقم أو المشتري أو الرقم الضريبي',
    filter: 'تضييق النتائج',
    filterTitle: 'تضييق المستندات',
    filterCount: (n: number) => `تضييق النتائج (${n})`,
    filterStatus: 'مرحلة المستند',
    filterTaxStatus: 'حالة المصلحة',
    filterFrom: 'من تاريخ',
    filterTo: 'إلى تاريخ',
    filterCustomer: 'المشتري',
    filterMin: 'أقل مبلغ (ج.م)',
    filterMax: 'أعلى مبلغ (ج.م)',
    applyFilter: 'عرض النتائج',
    clearFilter: 'مسح الكل',
    columns: {
      number: 'رقم المستند',
      customer: 'المشتري',
      date: 'تاريخ المستند',
      amount: 'الإجمالي بالجنيه',
      status: 'مرحلة المستند',
      taxStatus: 'حالة المصلحة',
      actions: 'أدوات المستند',
      updated: 'آخر تغيير',
      select: 'اختيار',
      reference: 'المستند المرجعي',
    },
    sortBy: (column: string) => `ترتيب حسب ${column}`,
    cash: 'مشترٍ بلا بيانات',
    noCustomer: 'لم يُحدد المشتري بعد',
    // الكتلة 11 (WP-11.4): الاسم الظاهر لعنصر «+n» في عمود المستند المرجعي.
    referenceMore: (n: number) => `و ${n} مستندات أخرى`,
    latest: 'آخر ما تم تحديثه',
    latestEmpty: 'سيظهر هنا آخر ما تم على مستنداتك.',
    rowActions: (number: string) => `إجراءات ${number}`,
    declineUntil: (date: string) => `يمكن الاعتراض حتى ${date}`,
    declineRunning: 'مهلة الاعتراض جارية',
    // Block 11 (RB3R11-11): a live cancellation on a «صالحة» row, so a request needing a release is
    // visible from the list; honest wording, never «ملغاة».
    cancellationRequested: 'طلب إلغاء قيد الإرسال',
    cancellationUnconfirmed: 'طلب إلغاء بانتظار تأكيد المصلحة',
    cancellationPending: (date: string) => `إلغاء معلّق حتى ${date} ما لم يُعترض`,
    cancellationPendingNoDate: 'طلب إلغاء لدى المصلحة',
    open: 'فتح',
    copyAs: 'نسخ إلى',
    copyInvoice: 'فاتورة',
    downloadPdf: 'حفظ نسخة PDF',
    issueSend: 'أصدِر وأرسِل للمصلحة',
    delete: 'احذف المسودة',
    edit: 'عدّل المسودة',
    copied: (number: string) => `أُنشئت نسخة برقم ${number}.`,
    /** صحّح وأعد الإرسال (WP-1b.2): المسودة البديلة لمستند رفضته المصلحة. */
    correctionCreated: (number: string) => `أُنشئت مسودة التصحيح ${number}.`,
    correctionOpen: (number: string) => `مسودة التصحيح ${number} مفتوحة بالفعل.`,
    deleted: (number: string) => `حُذفت ${number}. يبقى رقمها وتظهر كمسودة محذوفة.`,
    undo: 'تراجع',
    pdfReady: 'تم تنزيل ملف PDF.',
    /** الختم الإلكتروني كخطوة منفصلة (WP-1b.1): اختم فاتورة صادرة غير مختومة ثم أرسِلها. */
    sign: 'اختم الفاتورة إلكترونيًا',
    sendToEta: 'أرسِل الفاتورة المختومة',
    signed: (number: string) => `تم ختم ${number}. يُحفظ الختم الإلكتروني دون تغيير.`,
    sent: 'أُرسلت إلى مصلحة الضرائب بختمها المحفوظ.',
    signConfirmTitle: 'ختم هذه الفاتورة؟',
    signConfirmBody:
      'يُجمّد الختم الإلكتروني الفاتورة. يُحفظ التوقيع ويُرسل إلى مصلحة الضرائب كما وُقّع تمامًا دون أي تغيير لاحق.',
    signConfirmLabel: 'اختم',
    sendConfirmTitle: 'إرسال هذه الفاتورة المختومة؟',
    sendConfirmBody: 'تُرسل الفاتورة المختومة إلى مصلحة الضرائب بنفس البايتات التي وُقّعت.',
    sendConfirmLabel: 'أرسِل',
    updating: 'جارٍ التحديث…',
    kpis: {
      mockNote: 'هذه الأرقام من محاكي المصلحة، لا من المنظومة الحقيقية.',
      drafts: 'مسودات',
      sending: 'لدى المصلحة الآن',
      valid: 'صالحة',
      attention: 'تحتاج متابعة',
      validTotal: 'إجمالي الصالحة (ج.م)',
    },
    pageFirst: 'الصفحة الأولى',
    pageLast: 'الصفحة الأخيرة',
    foreignAmount: (amount: string, currency: string) => `${amount} ${currency}`,
    voidNote: 'مسودة محذوفة: يبقى الرقم ولا يُعاد استخدامه.',
    findLabel: 'البحث والتضييق',
    views: 'عروض جاهزة',
    viewAll: 'كل المستندات',
    viewDeleted: 'مسودات محذوفة',
    selectRow: (number: string) => `اختيار ${number}`,
    selectedDoc: (number: string) => `المستند المختار: ${number}`,
    selectPrompt: 'اختر مستندًا لتظهر أدواته هنا.',
    selectAnnounce: (number: string) => `اخترت ${number}. أدوات المستند فوق الجدول.`,
    latestLine: (number: string) => `آخر ما تم تحديثه: ${number}`,
    /** مدخل صفحة الحزمة من القائمة (WP-1b.3): رابط داخل كتلة لوحة البحث نفسها. */
    batchEntry: {
      title: 'العمل على عدة مستندات',
      hint: 'اجمع حتى 100 مستند وراجِعها، ثم نفِّذ عليها مهمة واحدة. لكل مستند نتيجته.',
      link: 'جهّز حزمة مستندات من هذه النتائج',
    },
  },
  /** صفحة الحزمة (Block 1b، WP-1b.3، MF-INV-008؛ BLOCK-1B-BULK-DESIGN §11). */
  batch: {
    title: 'تجهيز حزمة مستندات',
    lead: 'اختر المهمة، ثم المستندات، ثم راجِع ونفِّذ. يُنفَّذ كل مستند وحده.',
    steps: {
      label: 'خطوات الحزمة',
      task: 'المهمة',
      documents: 'المستندات',
      review: 'المراجعة والتنفيذ',
      needsInput: 'تحتاج إجراءً منك',
    },
    tasks: {
      legend: 'ماذا تفعل الحزمة؟',
      sendHint: 'للمسودات الجاهزة وللمستندات الصادرة التي لم تُرسل بعد. لا يُرسل مستند مرتين.',
      pdf: 'احفظ نسخ PDF في ملف واحد',
      pdfHint: 'ملف مضغوط فيه نسخة PDF لكل مستند كما هو الآن.',
      discard: 'احذف مسودات',
      discardHint: 'للمسودات فقط. يبقى رقم كل مسودة ولا يُعاد استخدامه، ولك 6 ثوانٍ للتراجع.',
    },
    fromResults: 'من نتائج القائمة',
    criteria: (criteria: string) => `المعايير: ${criteria}`,
    changeCriteria: 'غيّر المعايير في القائمة',
    noTask: 'اختر المهمة أولًا، فهي تحدد المستندات التي تظهر هنا.',
    preview: { caption: 'نتائج القائمة التي تنطبق عليها المهمة' },
    putAll: 'أضف كل النتائج، حتى 100 مستند',
    putAllDone: (n: string) => `أُضيف إلى الحزمة: ${n}.`,
    full: 'امتلأت الحزمة. الحد 100 مستند.',
    trimmed: (n: string) =>
      `تطابق المعايير ${n} مستندًا، فأُضيف منها ما يتّسع له المكان بالترتيب الحالي. نفِّذ هذه الحزمة ثم جهّز التالية.`,
    candidatesEmpty: 'لا مستندات هنا تنطبق عليها هذه المهمة',
    candidatesEmptyBody: 'غيّر المعايير في القائمة، أو اختر مهمة أخرى.',
    oneDocument: 'مستند بعينه',
    addField: 'أضف مستندًا إلى الحزمة',
    rail: {
      title: 'الحزمة',
      task: (task: string) => `المهمة: ${task}`,
      room: (n: string) => `المكان المتبقي: ${n} من 100`,
      empty: 'الحزمة فارغة. أضف إليها كل النتائج أو مستندًا بعينه.',
      takeOut: 'أخرِج',
      takeOutNamed: (number: string) => `أخرِج ${number} من الحزمة`,
      clear: 'إفراغ الحزمة',
      clearTitle: 'إفراغ الحزمة؟',
      clearBody: 'تخرج كل المستندات من الحزمة، ولا يتغيّر أي مستند.',
      clearConfirm: 'أفرِغها',
    },
    review: {
      title: 'راجِع الحزمة قبل التنفيذ',
      checking: 'جارٍ فحص كل مستند…',
      outcome: 'ما سيحدث',
      willRun: 'سيُنفَّذ',
      willSkip: (reason: string) => `سيُتخطّى: ${reason}`,
      summary: (run: string, skip: string) => `سيُنفَّذ على ${run}، ويُتخطّى ${skip}.`,
      total: (amount: string) => `إجمالي ما سيُرسل بالجنيه: ${amount}`,
      dropSkipped: 'أخرِج ما سيُتخطّى',
      nothing: 'لا شيء سيُنفَّذ: كل مستندات الحزمة ستُتخطّى.',
    },
    run: {
      send: 'أصدِر الحزمة وأرسِلها',
      pdf: 'احفظ ملف الحزمة',
      discard: 'احذف مسودات الحزمة',
    },
    confirm: {
      sendTitle: 'إصدار الحزمة وإرسالها؟',
      sendBody:
        'يُصدَر كل مستند ويُرسل وحده. لا رجوع عن مستند صدر، وما لا تنطبق عليه المهمة يُتخطّى.',
      documents: 'المستندات التي ستُنفَّذ',
      discardTitle: 'حذف مسودات الحزمة؟',
      discardBody: 'تُحذف كل مسودة وحدها، ويبقى رقمها ولا يُعاد استخدامه. لك 6 ثوانٍ للتراجع.',
    },
    undo: 'ستُحذف مسودات الحزمة بعد لحظات.',
    leaveGuard: 'يُجهَّز الملف الآن. إن غادرت فلن يُحفظ.',
    progress: 'جارٍ التنفيذ على الخادم…',
    progressFile: (done: string, total: string) => `جارٍ تجهيز الملف: ${done} من ${total}`,
    results: {
      title: 'نتيجة الحزمة',
      summary: (done: string, skipped: string, failed: string, waiting: string) =>
        `النتيجة: اكتمل ${done}، وتُخطّي ${skipped}، ولم يكتمل ${failed}، ولدى المصلحة الآن ${waiting}.`,
      done: 'اكتمل',
      skipped: 'تُخطّي',
      failed: 'لم يكتمل',
      code: 'رمز النتيجة',
      outcome: 'ما حدث',
      next: 'الخطوة التالية',
      following: 'تتابع الصفحة ردّ المصلحة على كل مستند.',
      lost: 'توقفت متابعة الحزمة قبل وصول كل النتائج. كل صف يعرض حالة المستند الآن.',
      unconfirmed: (state: string) => `لم تُؤكَّد النتيجة؛ حالته الآن: ${state}`,
      unconfirmedCount: (n: string) => `لم تُؤكَّد نتيجة ${n}؛ يعرض كل صف منها حالة مستنده الآن.`,
      retry: 'أعِد محاولة ما لم يكتمل',
      new: 'ابدأ حزمة جديدة',
      back: 'العودة إلى مستندات الفوترة',
      saveAgain: 'احفظ الملف مرة أخرى',
      openDoc: 'افتح المستند',
      finishDraft: 'أكمِلها في المحرر',
    },
    /** RIB-01 (DEC-046): leaving results that are not settled asks first. */
    leave: {
      title: 'ترك نتائج هذا التنفيذ؟',
      body: 'ما زال في النتائج مستندات لدى المصلحة الآن أو لم يكتمل تنفيذها أو لم تُؤكَّد نتيجتها. لا يتغيّر أي مستند، لكن هذه الصفحة لن تتابعها بعد ذلك.',
      confirm: 'اترك النتائج',
    },
    lockedByRun:
      'هذه الحزمة تحمل نتائج تنفيذ، فلا تتغيّر مستنداتها. لتجهيز مستندات أخرى ابدأ حزمة جديدة.',
    retryTitle: 'إعادة محاولة ما لم يكتمل؟',
    retryBody: 'تُنفَّذ المهمة على كل مستند كما هو الآن.',
    /** RIM-07: shown only where the table is in view beside the dialog (not on phones). */
    retryPointer: 'ما سيحدث لكل مستند معلَّم في الجدول.',
    reasons: {
      notFound: 'غير موجود، أو ليس في هذه المنشأة',
      sentBefore: 'له حالة لدى المصلحة؛ لا يُرسل مرتين',
      notDraft: 'ليس مسودة',
      notSendable: 'لا يُرسل في مرحلته الحالية',
      incomplete: 'المسودة غير مكتملة',
      permission: 'لا تملك صلاحية هذه المهمة على هذا المستند',
      changed: 'تغيّر بعد مراجعتك',
      ourSide: 'تعذّر التنفيذ لخلل من جهتنا',
      etaAnswer: (answer: string) => `ردّ المصلحة: ${answer}`,
      notReached: 'لم تصل النتيجة، ولم يتغيّر المستند',
    },
    errors: { tooMany: 'الحد 100 مستند في الحزمة الواحدة.' },
    announce: {
      put: (number: string) => `${number} في الحزمة الآن.`,
      out: (number: string) => `خرج ${number} من الحزمة.`,
      finished: 'انتهى التنفيذ.',
    },
  },
  receipts: {
    eyebrow: 'الفوترة',
    title: 'الإيصالات الإلكترونية',
    newReceipt: 'ابدأ إيصالًا',
    newReturn: 'ابدأ مرتجعًا بدون مرجع',
    startMenu: 'ابدأ إيصالًا',
    emptyTitle: 'لا توجد إيصالات بعد',
    emptyBody: 'أنشئ إيصالك الأول؛ يحصل على رقمه بمجرد حفظه.',
    noResultsTitle: 'لا توجد نتائج مطابقة',
    noResultsBody: 'جرّب بحثًا آخر، أو امسح عوامل التصفية.',
    search: 'البحث في الإيصالات',
    searchHint: 'رقم الإيصال أو المشتري',
    filter: 'تضييق النتائج',
    filterTitle: 'تضييق الإيصالات',
    filterCount: (n: number) => `تضييق النتائج (${n})`,
    filterStatus: 'مرحلة الإيصال',
    filterTaxStatus: 'حالة المصلحة',
    filterType: 'نوع الإيصال',
    filterAllTypes: 'كل الأنواع',
    clearFilter: 'مسح الكل',
    applyFilter: 'عرض النتائج',
    columns: {
      number: 'رقم الإيصال ونوعه',
      buyer: 'المشتري',
      date: 'تاريخ الإيصال',
      amount: 'إجمالي الإيصال',
      status: 'المرحلة وحالة المصلحة',
      updated: 'آخر تغيير',
    },
    sortBy: (column: string) => `ترتيب حسب ${column}`,
    noBuyer: 'لم يُحدد المشتري بعد',
    anonymousBuyer: 'مشترٍ بلا بيانات',
    notAccepted: 'لم تُقبل عند الإرسال',
    updating: 'جارٍ التحديث…',
    findLabel: 'البحث والتضييق',
    rowActions: (number: string) => `إجراءات ${number}`,
    open: 'فتح',
    issueSend: 'أصدِر وأرسِل للمصلحة',
    editDraft: 'عدّل المسودة',
    latestLine: (number: string) => `آخر ما تم تحديثه: ${number}`,
    confirm: {
      title: (number: string) => `اعتماد الإيصال ${number} نهائيًا لدى مصلحة الضرائب؟`,
      body: 'بعد الإصدار لا يمكن تعديل الإيصال، ويأخذ مكانه التالي في سلسلة إيصالات الجهاز.',
      noAmounts: 'تعذّر حساب المبالغ بعد؛ سيُبيّن الإصدار ما ينقص.',
    },
    paymentMethods: {
      C: 'نقدًا',
      V: 'بطاقة فيزا',
      CC: 'نقدًا مع مقاول',
      VC: 'بطاقة فيزا مع مقاول',
      VO: 'قسائم شراء',
      PR: 'عرض ترويجي',
      GC: 'بطاقة هدية',
      P: 'نقاط ولاء',
      O: 'طريقة أخرى',
    } as Record<string, string>,
    types: {
      s: 'إيصال بيع',
      r: 'مرتجع بإيصال مرجعي',
      RWR: 'مرتجع بدون مرجع',
      SC: 'بيع مطاعم ومقاهٍ',
      RC: 'مرتجع مطاعم ومقاهٍ',
      SS: 'بيع خدمات عامة',
      RS: 'مرتجع خدمات عامة',
      SR: 'بيع تجزئة',
      RR: 'مرتجع تجزئة',
      ST: 'بيع نقل',
      RT: 'مرتجع نقل',
      SB: 'بيع بنكي',
      RB: 'مرتجع بنكي',
      SE: 'بيع تعليمي',
      RE: 'مرتجع تعليمي',
      SP: 'بيع خدمات مهنية',
      RP: 'مرتجع خدمات مهنية',
      SH: 'بيع شحن',
      RH: 'مرتجع شحن',
      SN: 'بيع ترفيه',
      RN: 'مرتجع ترفيه',
      SU: 'بيع مرافق',
      RU: 'مرتجع مرافق',
    },
    editor: {
      newTitle: 'ابدأ إيصالًا',
      returnTitle: 'مرتجع بدون مرجع',
      choose: 'اختر من القائمة',
      noPermission: 'لا تملك صلاحية إنشاء الإيصالات أو تعديلها. اطلب ذلك ممن يدير المنشأة.',
      backToList: 'العودة إلى الإيصالات الإلكترونية',
      correctionOf: (number: string) =>
        `تصحيح للإيصال ${number}: راجِعه ثم احفظه. يأخذ رقمًا جديدًا عند أول حفظ، ويبقى ${number} كما هو.`,
      returnOf: (number: string) =>
        `مرتجع للإيصال ${number}: أبقِ البنود والكميات المرتجعة فقط، ثم احفظ.`,
      editTitle: (number: string) => `تحرير ${number}`,
      numberProvisional: 'يُخصص عند الحفظ',
      numberNext: (n: string) => `الرقم التالي: ${n}`,
      issuedFromTitle: 'من أين يصدر الإيصال',
      receiptTitle: 'الإيصال',
      linesTitle: 'بنود الإيصال',
      type: 'نوع الإيصال',
      typeLocked: 'يحتفظ الإيصال المحفوظ بنوعه.',
      pos: 'جهاز نقطة البيع',
      posHint: 'يحدد الجهاز فرع الإصدار وسلسلة ترقيم الإيصال.',
      noDevice:
        'لا يوجد جهاز نقطة بيع في الخدمة في هذه المنشأة بعد، فلا يُحفظ إيصال قبل تسجيل جهاز.',
      noDeviceStaff:
        'لا يوجد جهاز نقطة بيع في الخدمة في هذه المنشأة بعد. اطلب من مسؤول المنشأة تسجيل جهاز نقطة بيع ليتسنى حفظ الإيصالات.',
      missingPos: 'اختر جهاز نقطة البيع.',
      missingPosNone: 'لا يوجد جهاز نقطة بيع في الخدمة.',
      missingType: 'اختر نوع الإيصال.',
      branch: 'فرع الإصدار',
      branchFromDevice: 'يتبع جهاز نقطة البيع المختار.',
      branchNone: 'يظهر بعد اختيار الجهاز.',
      branchCode: (code: string) => `رقم الفرع لدى المصلحة ${code}`,
      activityCode: 'رمز نشاط المموّل',
      currency: 'عملة الإيصال',
      exchangeRate: 'سعر التحويل إلى الجنيه',
      rateHint: (currency: string) => `كمية الجنيه مقابل 1 ${currency}، حتى 5 أرقام عشرية.`,
      issueDate: 'تاريخ الإيصال',
      issueDateHint: 'اتركه فارغًا لاستخدام لحظة الإصدار.',
      paymentMethod: 'طريقة السداد',
      paymentMethodHint: 'من قائمة طرق السداد الرسمية لدى المصلحة.',
      returnTitleField: 'ترويسة المرتجع',
      referenceUuid: 'إيصال البيع المُرتجَع',
      referenceChosen: 'إيصال البيع المختار:',
      referenceUuidHint:
        'ابحث برقم الإيصال أو تاريخه (سنة-شهر-يوم) أو اسم المشتري. تظهر إيصالات البيع الصالحة فقط.',
      referenceUuidRequired: 'اختر إيصال البيع الذي يُرتجَع.',
      documentUseReason: 'سبب الإرجاع',
      useReasons: {
        I: 'مرتجع دولي',
        B: 'بيع صدر قبل التطبيق',
      },
      salesIssuedDateTime: 'تاريخ البيع الأصلي',
      salesIssuedDateTimeHint: 'تاريخ إصدار إيصال البيع الأصلي.',
      rwrMandatory: 'يحتاج المرتجع بدون مرجع إلى السبب وتاريخ البيع الأصلي معًا.',
      rwrMissingReason: 'اختر سبب الإرجاع.',
      rwrMissingDate: 'أدخل تاريخ البيع الأصلي.',
      buyerTitle: 'المشتري',
      buyerType: 'فئة المشتري',
      buyerTypes: {
        B: 'منشأة في مصر',
        P: 'شخص طبيعي',
        F: 'طرف أجنبي',
      },
      buyerId: 'رقم تعريف المشتري',
      buyerName: 'اسم المشتري',
      buyerMobile: 'هاتف المشتري',
      item: 'المنتج أو الخدمة',
      quantity: 'الكمية المبيعة',
      unitPrice: (currency: string) => `سعر الوحدة (${currency})`,
      addLine: 'أضف بندًا',
      removeLine: 'احذف البند',
      noLines: 'لا توجد بنود بعد. أضف أول بند.',
      summaryTitle: 'المبالغ كما ستصدر',
      summaryNote: 'يحسبها الخادم الآن بالطريقة التي يُصدَر بها الإيصال، وتتحدّث مع كل تعديل.',
      summaryEmpty: 'أضف بندًا لتظهر المبالغ.',
      summaryIncomplete: 'تظهر المبالغ حين تكتمل بيانات البنود.',
      summaryUpdating: 'جارٍ الحساب…',
      linePath: (n: string, field: string) => `البند ${n}: ${field}`,
      lineTaxes: 'الضرائب على البند',
      taxRate: (rate: string) => `بنسبة ${rate}٪`,
      feeAmount: (name: string, currency: string) => `مبلغ ${name} (${currency})`,
      feeAmountHint: (code: string) => `مبلغ ثابت للبند كله، بلا نسبة · ${code}`,
      saveDraft: 'احفظ وأكمل لاحقًا',
      saving: 'جارٍ الحفظ…',
      saved: 'تم حفظ المسودة.',
    },
    detail: {
      title: (number: string) => `إيصال إلكتروني ${number}`,
      valuesTitle: 'الإيصال',
      linesTitle: 'البنود',
      taxesTitle: 'إجماليات الضرائب',
      totalsTitle: 'الإجماليات',
      etaTitle: 'مصلحة الضرائب',
      historyTitle: 'السجل',
      number: 'الرقم',
      type: 'الفئة',
      issueDate: 'تاريخ الإيصال',
      issuedAt: 'وقت الإصدار',
      currency: 'عملة الإيصال',
      exchangeRate: 'سعر التحويل إلى الجنيه',
      activity: 'رمز نشاط المموّل',
      pos: 'جهاز نقطة البيع',
      branch: 'فرع الإصدار',
      paymentMethod: 'طريقة السداد',
      buyerType: 'فئة المشتري',
      buyerId: 'رقم تعريف المشتري',
      buyerName: 'اسم المشتري',
      documentUseReason: 'سبب الإرجاع',
      salesIssuedDateTime: 'تاريخ البيع الأصلي',
      referenceUuid: 'معرّف الإيصال المرجعي',
      referenceReceipt: 'إيصال البيع المرجعي',
      uuid: 'معرّف الإيصال',
      previousUuid: 'الإيصال السابق على هذا الجهاز',
      previousNone: 'هذا أول إيصال على هذا الجهاز.',
      previousAtIssue: 'يُربط بآخر إيصال على الجهاز عند إصداره.',
      chainHead: 'آخر إيصال على هذا الجهاز',
      createdAt: 'أُنشئ في',
      readOnly: 'الإيصالات الصادرة للقراءة فقط.',
      draftNote: 'المبالغ أدناه محسوبة الآن كما ستصدر، وتُثبَّت عند إصدار الإيصال.',
      draftNoAmounts: 'تظهر المبالغ حين تكتمل بيانات البنود.',
      notFoundTitle: 'لم نجد هذا الإيصال',
      notFoundBody: 'ربما كُتب الرابط بشكل خاطئ، أو يخص الإيصال منشأة أخرى.',
      notAcceptedQualifier: 'لم تُقبل عند الإرسال، فسُجّلت «غير صالحة»',
      reasonNotAccepted: 'لم تقبل مصلحة الضرائب الإيصال عند إرساله، لذلك حالته لديها «غير صالحة».',
      reasonInvalid: 'راجعت مصلحة الضرائب الإيصال ووجدته غير صالح.',
      reasonCancelled: 'ألغى مراجِع في مصلحة الضرائب الإيصال بعد قبوله.',
      reasonLive: 'الإيصال لدى مصلحة الضرائب الآن، وتتحدّث هذه الصفحة وحدها.',
      reasonUnknownCode: 'لم تذكر المصلحة سببًا نعرفه؛ التفاصيل الفنية أدناه.',
      reasonStep: 'الفحص الذي لم يجتزه:',
      reasonCodes: {
        'MOCK-NOT-ACCEPTED': 'رفض محاكى عن قصد في البيئة التجريبية؛ لا يصل شيء إلى المصلحة.',
        'MOCK-INVALID': 'نتيجة محاكاة عن قصد في البيئة التجريبية؛ لا يصل شيء إلى المصلحة.',
        BadStructure: 'بنية الإيصال المرسَلة لا تطابق ما تطلبه المصلحة.',
        MaximumSizeExceeded: 'تجاوز حجم الإرسال الحد الذي تقبله المصلحة.',
        DuplicateSubmission: 'أُرسل الطلب نفسه قبل قليل؛ تتحقق المنصة من نتيجته قبل أي إعادة.',
      } as Record<string, string>,
      techDetails: 'التفاصيل الفنية',
      correctAction: 'ابدأ إيصالًا مصححًا',
      correctHint: 'تُفتح مسودة جديدة بالبيانات نفسها لتصححها ثم تصدرها؛ يبقى هذا الإيصال كما هو.',
      returnAction: 'ابدأ مرتجعًا لهذا الإيصال',
      eventReasons: {
        'HTTP 429': 'طلبت المصلحة التمهّل؛ أُعيدت المحاولة تلقائيًا.',
        'HTTP 503': 'المصلحة غير متاحة مؤقتًا؛ أُعيدت المحاولة تلقائيًا.',
      } as Record<string, string>,
      taxType: 'الفئة الضريبية',
      taxAmount: 'قيمة الضريبة',
      totalSales: 'قيمة المبيعات',
      netAmount: 'الصافي بعد الخصومات',
      totalAmount: 'الإجمالي النهائي',
      lineTotal: 'إجمالي البند',
      etaStatus: 'حالة المصلحة',
      etaReason: 'السبب',
      etaEnvironment: 'البيئة',
      etaUuid: 'معرّف الإيصال لدى المصلحة',
      etaSyncedAt: 'آخر فحص',
      issuing: 'جارٍ الإصدار…',
      issuedToast: (number: string) => `أُصدر ${number} وأُرسل.`,
      events: {
        draft_created: 'أُنشئت المسودة',
        draft_saved: 'حُفظت المسودة',
        issued: 'صدر',
        eta_submission_requested: 'أُرسل إلى مصلحة الضرائب',
        eta_accepted_for_validation: 'قُبل للتحقق',
        eta_valid: 'صالحة',
        eta_invalid: 'غير صالحة',
        eta_rejected: 'رفضها المستلم',
        eta_cancelled: 'أُلغيت',
        eta_submission_rejected: 'لم تُقبل عند الإرسال',
        eta_outcome_unknown: 'لا يوجد رد بعد — يجري التحقق',
        eta_reconciled: 'وُجدت لدى المصلحة',
        eta_retry_scheduled: 'المصلحة مشغولة — إعادة محاولة',
      } as Record<string, string>,
    },
  },
  editor: {
    newTitle: 'إنشاء فاتورة',
    newExportTitle: 'إنشاء فاتورة تصدير',
    editTitle: (number: string) => `تحرير ${number}`,
    number: 'الرقم',
    numberProvisional: 'يُخصص عند الحفظ',
    numberNext: (n: string) => `الرقم التالي: ${n}`,
    sections: {
      customer: 'المشتري',
      lines: 'بنود الفاتورة',
      totals: 'الملخص',
      additional: 'مراجع الطلب',
      issuer: 'المُصدِر',
      readiness: 'قبل الإصدار',
    },
    customer: {
      search: 'المشتري',
      placeholder: 'ابحث بالاسم أو الرقم الضريبي أو الهاتف',
      newCustomer: 'مشترٍ جديد',
      cash: 'مشترٍ بلا بيانات',
      cashHint: 'شخص بدون رقم تعريف. تطبّق مصلحة الضرائب حدًا لا تعلنه.',
      change: 'تغيير المشتري',
      edit: 'تعديل بيانات المشتري',
      details: 'عرض التفاصيل',
      hideDetails: 'إخفاء التفاصيل',
      none: 'اختر مشتريًا، أو أضف مشتريًا جديدًا، أو أصدر لمشترٍ بلا بيانات.',
    },
    lines: {
      addItems: 'الاختيار من الكتالوج',
      addItemsHint: 'ابحث في أصنافك واختر عدة أصناف دفعة واحدة.',
      empty: 'الفاتورة بلا بنود حتى الآن. اختر من كتالوج أصنافك.',
      item: 'السلعة أو الخدمة',
      quantity: 'الكمية المبيعة',
      unitPrice: (currency: string) => `سعر الوحدة (${currency})`,
      fromCatalogue: 'من الكتالوج',
      discount: 'الخصم (ج.م)',
      discountPercent: '٪',
      discountAmount: 'ج.م',
      discountMode: 'الخصم بصيغة',
      itemsDiscount: 'خصم الأصناف (ج.م)',
      valueDifference: 'فرق القيمة (ج.م)',
      taxes: 'ضرائب البند',
      noTaxes: 'بدون ضريبة',
      addTax: 'أضف ضريبة أخرى',
      removeTax: (name: string) => `إزالة ${name}`,
      fixedAmount: (name: string) => `مبلغ ${name} (ج.م)`,
      total: 'إجمالي البند',
      remove: 'حذف البند',
      more: 'خيارات أكثر',
      less: 'خيارات أقل',
      weightUnit: 'وحدة الوزن',
      weightQuantity: 'الوزن',
      editItem: 'تعديل الصنف',
      lineLabel: (n: number) => `البند ${n}`,
    },
    totals: {
      salesTotal: 'مجموع قيم البيع',
      discount: 'خصومات البنود',
      net: 'القيمة بعد الخصم',
      itemsDiscount: 'خصومات الأصناف بعد الضريبة',
      extraDiscount: 'خصم على إجمالي المستند (ج.م)',
      total: 'إجمالي المستند',
      amountDue: 'المستحق على المشتري (ج.م)',
      amountDueForeign: (currency: string) => `المستحق على المشتري بعملة ${currency} (للعرض فقط)`,
      // اتجاه إشعار الدائن (الكتلة 11، WP-11.4؛ قرار الدور 2، R-2): الإشعار يردّ القيمة للمشتري.
      amountDueCredit: 'المستحق للمشتري (ج.م)',
      amountDueCreditForeign: (currency: string) => `المستحق للمشتري بعملة ${currency} (للعرض فقط)`,
      deducted: 'يُخصم',
      egpNote: 'كل المبالغ بالجنيه المصري عدا سعر الوحدة.',
      waiting: 'يظهر الملخص عندما تكتمل البنود.',
    },
    settings: {
      issueDate: 'تاريخ المستند',
      issueDateHint: 'اتركه فارغًا ليُستخدم وقت الإصدار.',
      dueDate: 'موعد السداد',
      type: 'وجهة البيع',
      local: 'داخل مصر',
      export: 'للتصدير',
      exportHint: 'فاتورة التصدير تحتاج مشتريًا أجنبيًا، ووزنًا لكل بند، وتاريخ أداء الخدمة.',
      currency: 'عملة المستند',
      exchangeRate: 'سعر التحويل إلى الجنيه',
      rateHint: (currency: string) => `جنيه مصري مقابل 1 ${currency}، حتى 5 أرقام عشرية.`,
      activityCode: 'رمز نشاط المموّل',
      branch: 'فرع الإصدار',
      serviceDate: 'تاريخ أداء الخدمة',
      typeLocked: 'يحتفظ المستند المحفوظ بعائلة نوعه.',
    },
    additional: {
      poRef: 'رقم أمر شراء المشتري',
      poDesc: 'تفاصيل أمر الشراء',
      soRef: 'رقم أمر البيع لدينا',
      soDesc: 'تفاصيل أمر البيع',
      proforma: 'مرجع الفاتورة المبدئية',
    },
    readiness: {
      ready: 'جاهزة للإصدار',
      incomplete: (n: number) =>
        n === 1 ? 'ملاحظة واحدة تحتاج تصحيحًا' : `${n} ملاحظات تحتاج تصحيحًا`,
      localOnly: 'هذه فحوص محلية. مصلحة الضرائب تتحقق من الفاتورة بعد إرسالها.',
      // Block 11 (role-4 m-1): a note's readiness line names the note, not «الفاتورة».
      localOnlyNote: 'هذه فحوص محلية. مصلحة الضرائب تتحقق من الإشعار بعد إرساله.',
      warnings: 'تستحق المراجعة',
      goTo: 'الانتقال إلى الحقل',
    },
    saveDraft: 'احفظ وأكمل لاحقًا',
    saving: 'جارٍ الحفظ…',
    saved: 'تم حفظ المسودة.',
    savedAt: (time: string) => `حُفظت ${time}`,
    unsaved: 'تغييرات غير محفوظة',
    issueSend: 'أصدِر وأرسِل للمصلحة',
    conflictTitle: 'عدّل شخص آخر هذه المسودة',
    conflictBody: 'تعديلاتك ما زالت هنا. حمّل أحدث نسخة، أو انسخ تعديلاتك أولًا.',
    loadLatest: 'تحميل أحدث نسخة',
    confirm: {
      title: 'إصدار الفاتورة وإرسالها لمصلحة الضرائب؟',
      body: 'بعد الإصدار لا يمكن تعديل الفاتورة أو حذفها.',
      /** الكتلة 11 (m-1): صياغة تأكيد الإصدار الخاصة بالإشعار (ليست «الفاتورة»). */
      titleNote: 'إصدار الإشعار وإرساله لمصلحة الضرائب؟',
      bodyNote: 'بعد الإصدار لا يمكن تعديل الإشعار أو حذفه.',
      organization: 'المُصدِر',
      environment: 'البيئة',
      customer: 'المشتري',
      number: 'الرقم',
      total: 'إجمالي المستند',
      confirm: 'أصدِر وأرسِل للمصلحة',
      /** WP-1b.4: صف نسخة المشتري بالبريد في ملخص التأكيد (عنوانه `editor.mail.title`). */
      mailSend: (email: string) => `تُرسَل إلى ${email} بعد أن تقبلها المصلحة`,
      mailNone: 'بلا نسخة بالبريد',
      mailTest: 'رسالة تجريبية تُحفظ في ملف',
      mailFromEditor: 'لإرسال نسخة للمشتري بالبريد، أصدِر الفاتورة من خطوة المراجعة في المحرر.',
      openReview: 'افتح خطوة المراجعة',
    },
    /** WP-1b.4 (MF-INV-010): كتلة الخطوة 4 «نسخة للمشتري بالبريد». */
    mail: {
      title: 'نسخة للمشتري بالبريد',
      lead: 'نستطيع أن نرسل إلى المشتري ملف PDF من الفاتورة بعد إصدارها. لا يُرسَل شيء ما لم تختره هنا.',
      none: 'لا تُرسِل نسخة',
      noneHint: 'تصدر الفاتورة وتُرسَل إلى مصلحة الضرائب فقط.',
      send: 'أرسِل نسخة PDF إلى هذا البريد',
      sendHint: 'تخرج الرسالة بعد أن تقبل مصلحة الضرائب الفاتورة، وتتابع حالتها في صفحة الفاتورة.',
      missing: 'لا يوجد بريد فواتير لهذا المشتري، فستصدر الفاتورة دون نسخة بالبريد.',
      invalid:
        'بريد الفواتير المسجّل لهذا المشتري ليس عنوانًا صالحًا، فستصدر الفاتورة دون نسخة بالبريد.',
      cash: 'المشتري بلا بيانات، فليس له عنوان نرسل إليه نسخة.',
      noBuyer: 'اختر المشتري أولًا، ثم عُد إلى هنا لتقرر إرسال نسخة له.',
      fix: 'أضِف البريد أو صحّحه في خطوة المشتري',
      change: 'غيّر البريد من خطوة المشتري',
      testNote: 'بيئة اختبار: لن تصل الرسالة إلى المشتري، بل تُحفظ في ملف على الخادم.',
      reset: 'تغيّر بريد المشتري، فعاد الاختيار إلى عدم الإرسال.',
    },
    issued: (number: string) => `صدرت ${number} وأُرسلت.`,
    copiedFrom: (number: string) => `منسوخة من ${number}.`,
    pricesCleared: 'تغيّرت العملة: أدخل أسعار الوحدات بالعملة الجديدة.',
    copyWarnings: 'راجع هذه النقاط قبل الإصدار:',
    /** مسودة تصحيح (WP-1b.2): ما تحل محله، وما ذكرته المصلحة عنه. */
    supersedesBanner: 'هذه مسودة تصحيح تحل محل فاتورة لم تقبلها مصلحة الضرائب:',
    supersedesHint: 'صحّح ما ذكرته مصلحة الضرائب ثم أصدِرها، فتُعلَّم تلك الفاتورة عندها مستبدلة.',
    supersedesReasons: (number: string) => `ما ذكرته مصلحة الضرائب عن ${number}`,
    leaveWarning: 'لديك تغييرات غير محفوظة.',
    steps: {
      label: 'خطوات الفاتورة',
      counter: (n: string, total: string) => `الخطوة ${n} من ${total}`,
      clean: 'لا شيء يحتاج تصحيحًا',
      announce: (n: string, total: string, name: string) => `الخطوة ${n} من ${total}: ${name}`,
      details: 'تفاصيل المستند',
      review: 'المراجعة والإصدار',
      reference: 'المستند المرجعي',
      noteLines: 'بنود الإشعار',
    },
    groups: {
      dates: 'التواريخ',
      money: 'عملة المستند وسعر التحويل',
    },
    back: 'رجوع',
    next: (step: string) => `متابعة إلى ${step}`,
    review: {
      title: 'راجِع الفاتورة قبل إصدارها',
      // Block 11 (role-4 m-1): a note's step-4 heading names the note, not «الفاتورة».
      titleNote: 'راجِع الإشعار قبل إصداره',
      backTo: (step: string) => `عُد إلى ${step}`,
      clean: 'لم تجد الفحوص ما يمنع الإصدار.',
      testingOnly: 'للاختبار فقط',
    },
    buyerChoice: {
      label: 'من المشتري؟',
      records: 'من سجل المشترين',
      newHint: 'منشأة مصرية أو فرد أو طرف خارج مصر، ويُحفظ في سجل المشترين.',
    },
    summary: {
      label: 'الفاتورة في لمحة',
      /** الكتلة 11 (m-1): عنوان لوحة الملخص على محرر الإشعار. */
      labelNote: 'الإشعار في لمحة',
    },
    /** محرر إشعارات الدائن والمدين (الكتلة 11، WP-11.4؛ notes-editor.md:27-110). */
    note: {
      createCredit: 'إنشاء إشعار الدائن',
      createDebit: 'إنشاء إشعار المدين',
      createExportCredit: 'إنشاء إشعار الدائن للتصدير',
      createExportDebit: 'إنشاء إشعار المدين للتصدير',
      rule: 'يُبنى الإشعار على فاتورة صالحة أو أكثر صادرة لنفس المشتري.',
      addField: 'أضف فاتورة مرجعية',
      addHint: 'ابحث برقم الفاتورة أو اسم المشتري أو رقم تسجيله',
      /** الكتلة 11 (m-2): تلميح البحث الخاص بورقة بنود المرجع (بنود الفاتورة، لا الفواتير). */
      addLineHint: 'ابحث في بنود المرجع بالصنف أو الكود',
      takeOut: 'أخرِج',
      buyer: (name: string) => `المشتري: ${name}`,
      fromReference: 'من الفاتورة المرجعية',
      fromReferenceField: 'مأخوذة من الفاتورة المرجعية',
      fromInvoice: (invoice: string) => `من ${invoice}`,
      fromLine: (line: number) => `البند ${line}`,
      referencedLine: 'البند المرجعي',
      addLine: 'أضف بندًا من المرجع',
      linesToNote: (n: number) =>
        n === 1 ? 'أضف بندًا واحدًا إلى الإشعار' : `أضف ${n} بنود إلى الإشعار`,
      noReference: 'اختر المستند المرجعي أولًا',
      backToReference: 'عُد إلى المستند المرجعي',
      stillReducible: 'المتبقي القابل للتخفيض',
      reducibleBefore: 'قبل هذا الإشعار',
      reducibleAfter: 'بعد هذا الإشعار',
      needsCancelPermission: 'إصدار إشعار الدائن يحتاج صلاحية الإلغاء لدى المصلحة',
    },
  },
  detail: {
    title: (number: string) => `فاتورة ${number}`,
    exportTitle: (number: string) => `فاتورة تصدير ${number}`,
    noteCreditTitle: (number: string) => `إشعار الدائن ${number}`,
    noteDebitTitle: (number: string) => `إشعار المدين ${number}`,
    kindLocal: 'فاتورة إلكترونية',
    kindExport: 'فاتورة تصدير إلكترونية',
    kindCredit: 'إشعار الدائن الإلكتروني',
    kindDebit: 'إشعار المدين الإلكتروني',
    kindExportCredit: 'إشعار الدائن الإلكتروني للتصدير',
    kindExportDebit: 'إشعار المدين الإلكتروني للتصدير',
    sections: {
      document: 'المستند',
      settings: 'خصائص المستند',
      activity: 'السجل الزمني',
      eta: 'مصلحة الضرائب',
    },
    seller: 'البائع',
    buyer: 'المشتري',
    issuedAt: 'وقت الإصدار',
    issueDate: 'تاريخ المستند',
    dueDate: 'موعد السداد',
    serviceDate: 'تاريخ أداء الخدمة',
    createdAt: 'أُنشئت',
    taxId: 'رقم التسجيل',
    nationalId: 'الرقم القومي',
    foreignId: 'الرقم الضريبي الأجنبي',
    type: 'طبيعة المستند',
    lines: 'البنود',
    amountDue: 'المستحق على المشتري',
    amountDueEgp: 'المستحق على المشتري (ج.م)',
    amountDueForeign: (currency: string) => `المستحق على المشتري (${currency})`,
    // اتجاه إشعار الدائن (الكتلة 11، WP-11.4؛ قرار الدور 2، R-2)، مطابق لملف PDF.
    amountDueCredit: 'المستحق للمشتري',
    amountDueCreditEgp: 'المستحق للمشتري (ج.م)',
    amountDueCreditForeign: (currency: string) => `المستحق للمشتري (${currency})`,
    currency: 'عملة المستند',
    exchangeRate: 'سعر التحويل إلى الجنيه',
    activity: 'نشاط المموّل',
    branch: 'فرع الإصدار',
    referenceDocuments: 'المستندات المرجعية',
    notesOnInvoice: 'إشعارات على هذه الفاتورة',
    stillReducible: 'المتبقي القابل للتخفيض',
    createCreditFromInvoice: 'أنشئ إشعار الدائن من هذه الفاتورة',
    createDebitFromInvoice: 'أنشئ إشعار المدين من هذه الفاتورة',
    deleteTitle: 'حذف هذه المسودة؟',
    deleteBody: (number: string) =>
      `ستظهر ${number} كمسودة محذوفة ولن يُعاد استخدام رقمها. يمكنك التراجع خلال ثوانٍ.`,
    deleteConfirm: 'احذف المسودة',
    copiedFromBanner: (number: string) => `نُسخت هذه المسودة من ${number}.`,
    copiesLabel: 'النسخ',
    /** WP-1b.2: الفاتورة المرفوضة وبديلتها يشير كلٌّ منهما إلى الآخر. */
    supersededBanner: 'استُبدلت هذه الفاتورة بفاتورة مُصحّحة:',
    supersedesBanner: 'تحل هذه الفاتورة محل فاتورة لم تقبلها مصلحة الضرائب:',
    /** حكم مصلحة الضرائب على مستند رفضته، حقلًا بحقل (WP-1b.2, MF-INV-009). */
    verdict: {
      title: 'نتيجة تحقق مصلحة الضرائب',
      lead: 'هذه أسباب مصلحة الضرائب كما أرسلتها، حقلًا بحقل. فحوصنا المحلية قبل الإصدار منفصلة عنها.',
      leadSubmission: 'رفضت مصلحة الضرائب استلام هذا المستند عند إرساله، فلم يصل إلى مرحلة التحقق.',
      steps: 'خطوات تحقق مصلحة الضرائب',
      submission: 'سبب رفضه عند الإرسال',
      passed: 'اجتازها',
      failed: 'لم يجتزها',
      field: 'الحقل',
      code: 'رمز المصلحة',
      noDetail: 'لم ترسل المصلحة تفاصيل لهذه الخطوة.',
      correct: 'صحّح وأعد الإرسال',
      correctHint:
        'يُنشئ مسودة جديدة برقمها الخاص فيها المشتري والبنود والإعدادات نفسها. تبقى هذه الفاتورة كما هي حتى تُصدر المسودة الجديدة، فتُعلَّم عندها مستبدلة.',
      continue: (number: string) => `تابِع التصحيح في ${number}`,
      openDraft: 'مسودة التصحيح مفتوحة:',
      noPermission: 'إنشاء مسودة التصحيح يحتاج صلاحية إنشاء المسودات.',
      replaced: 'صُحّحت واستُبدلت بالفاتورة:',
    },
    eta: {
      uuid: 'المعرّف لدى المصلحة',
      longId: 'المعرّف الطويل',
      environment: 'البيئة',
      reason: 'السبب',
      submissions: 'سجل الإرسال',
      attempts: (n: number) => (n === 1 ? 'محاولة واحدة' : `${n} محاولات`),
      steps: 'خطوات التحقق',
      notSent: 'لم تُرسل إلى مصلحة الضرائب بعد.',
      watching: 'قد تُبلغ المصلحة برفض أو إلغاء خلال مدة محدودة.',
      submissionStatus: {
        queued: 'في الانتظار',
        claimed: 'قيد التجهيز',
        sending: 'جارٍ الإرسال',
        accepted: 'استلمتها المصلحة للتحقق',
        partially_accepted: 'مقبول جزئيًا',
        rejected: 'غير مقبول',
        retry_wait: 'بانتظار إعادة المحاولة',
        unknown: 'جارٍ التحقق مع المصلحة',
        failed: 'تعذّر الإرسال',
      } as Record<string, string>,
    },
    actorSystem: 'النظام',
    events: {
      draft_created: 'أُنشئت المسودة',
      draft_saved: 'حُفظت المسودة',
      issued: 'صدرت نهائيًا',
      discarded: 'حُذفت المسودة',
      copied_from: 'أُنشئت كنسخة',
      copied_to: 'نُسخت',
      eta_submission_requested: 'أُرسلت إلى مصلحة الضرائب',
      eta_accepted_for_validation: 'قُبلت للتحقق',
      eta_valid: 'نتيجة التحقق: صالحة',
      eta_invalid: 'نتيجة التحقق: غير صالحة',
      eta_rejected: 'رفضها المستلم',
      // U-10 (W3-07; F-5, DEC-069): ETA's status alone does not settle a cancellation — the buyer may
      // still object inside their own period, which returns the document to valid. So the one event
      // became two, each true of its own read: this one while the objection period is not certainly
      // over, `eta_cancelled_final` once it is (`eta-watch.ts` `cancellationSettled`).
      eta_cancelled: 'تقول المصلحة: ملغاة — وقد يعترض المشتري ما لم تنتهِ مهلته',
      eta_cancelled_final: 'ألغت المصلحة هذا المستند، وانتهت مهلة اعتراض المشتري',
      eta_submission_rejected: 'لم تُقبل عند الإرسال',
      eta_outcome_unknown: 'لم يصل رد المصلحة — يجري التحقق قبل أي إعادة إرسال',
      eta_reconciled: 'وُجدت لدى المصلحة (لم تُرسل مرة أخرى)',
      eta_retry_scheduled: 'المصلحة مشغولة — إعادة المحاولة',
      correction_created: 'أُنشئت كمسودة تصحيح',
      correction_started: 'بدأ تصحيحها في مسودة جديدة',
      superseded: 'استُبدلت بفاتورة مُصحّحة',
      supersedes: 'صدرت بدلًا من فاتورة لم تقبلها المصلحة',
      signed: 'طُبّق الختم الإلكتروني',
      email_requested: 'طُلب إرسال نسخة للمشتري بالبريد',
      email_sent: 'سُلّمت نسخة المشتري لخادم البريد',
      email_saved: 'حُفظت نسخة المشتري كرسالة تجريبية',
      email_failed: 'تعذّر إرسال نسخة المشتري بالبريد',
      email_withheld: 'لم تُرسَل نسخة المشتري لأن المصلحة لم تقبل الفاتورة',
      email_retry: 'طُلبت محاولة أخرى لإرسال نسخة المشتري',
      eta_cancel_requested: 'طُلب الإلغاء لدى المصلحة',
      eta_cancel_sending: 'يخرج طلب الإلغاء الآن',
      eta_cancel_done: 'تسلّمت المصلحة طلب الإلغاء',
      eta_cancel_refused: 'رُفض طلب الإلغاء',
      eta_cancel_unknown: 'لم يصل رد المصلحة على طلب الإلغاء — نتحقق دون إعادة إرسال',
      eta_cancel_not_applied: 'لم يقع طلب الإلغاء',
      eta_cancel_failed: 'تعذّر إرسال طلب الإلغاء',
      eta_cancel_confirmed: 'أكدت المصلحة طلب الإلغاء',
      eta_cancel_unconfirmed: 'لم تؤكد المصلحة أثر طلب الإلغاء بعد',
      eta_cancel_release_requested: 'طُلب اعتبار طلب الإلغاء غير قائم',
      // F-4: what the release establishes, and nothing more (R-17: ETA may still apply the cancel).
      // B-1 (DEC-107): the vocabulary is the STANDING of the request, «قائم / غير قائم», with the
      // treating-as verb «اعتبر» — never «تحرير», which in the Egyptian accounting register means
      // DRAWING UP an instrument and is this product's own editor title («تحرير {رقم}»).
      eta_cancel_released: 'اعتُبر طلب الإلغاء غير قائم بعد قراءة أظهرت المستند صالحًا',
      // m-1: read alone in an export or a log, naming only the standing reads as neutral status;
      // the line has to say that what was asked did NOT happen, which «لم يُعتبر» does.
      eta_cancel_release_refused: 'لم يُعتبر طلب الإلغاء غير قائم؛ بقي قائمًا',
      eta_decline_rejection_requested: 'طُلب الاعتراض على رفض المشتري',
      eta_decline_rejection_sending: 'يخرج الاعتراض الآن',
      eta_decline_rejection_done: 'تسلّمت المصلحة الاعتراض',
      eta_decline_rejection_refused: 'رُفض الاعتراض',
      eta_decline_rejection_unknown: 'لم يصل رد المصلحة على الاعتراض — نتحقق دون إعادة إرسال',
      eta_decline_rejection_not_applied: 'لم يقع الاعتراض',
      eta_decline_rejection_failed: 'تعذّر إرسال الاعتراض',
      eta_decline_rejection_confirmed: 'أكدت المصلحة الاعتراض',
      eta_decline_rejection_unconfirmed: 'لم تؤكد المصلحة أثر الاعتراض بعد',
      eta_cancel_request_reported: 'أبلغت المصلحة بطلب إلغاء',
      eta_reject_request_reported: 'أبلغت المصلحة برفض المشتري',
      eta_cancel_declined: 'اعترض المشتري على الإلغاء',
      eta_rejection_declined: 'سجّلت المصلحة الاعتراض على الرفض',
    } as Record<string, string>,
    /** WP-1b.4: قسم «نسخة المشتري بالبريد» في صفحة الفاتورة؛ حالة التسليم مستقلة عن مرحلة المستند. */
    delivery: {
      title: 'نسخة المشتري بالبريد',
      waitingEta: 'تنتظر أن تقبل المصلحة الفاتورة.',
      none: 'لم تُطلب نسخة للمشتري بالبريد عند إصدار هذه الفاتورة.',
      // Block 11 (role-4 m-1): on a note's detail page the band names the note, not «الفاتورة».
      noneNote: 'لم تُطلب نسخة للمشتري بالبريد عند إصدار هذا الإشعار.',
      recipient: 'بريد المشتري',
      attempts: (n: string) => `المحاولات: ${n}`,
      sentAt: (time: string) => `سُلّمت في ${time}`,
      /** RIM-01: the file transport saved it; nothing was handed over. */
      savedAt: (time: string) => `حُفظت في ${time}`,
      lastAttempt: (time: string) => `آخر محاولة: ${time}`,
      nextAttempt: (time: string) => `محاولة تلقائية أخرى نحو ${time}`,
      reply: 'ردّ خادم البريد',
      retry: 'أعِد محاولة الإرسال',
      retried: 'عادت النسخة إلى طابور البريد.',
      /** RIM-03: the file type is rendered as an isolated code, the period outside it. */
      testNote: (file: string) =>
        `بيئة اختبار: لم تخرج الرسالة من الخادم، بل حُفظت في ملف بصيغة ${file} على الخادم.`,
      status: {
        queued: 'في طابور البريد',
        sending: 'تخرج الآن',
        sent: 'سلّمناها لخادم البريد',
        saved: 'حُفظت كرسالة تجريبية',
        failed: 'تعذّر إرسالها بالبريد',
        withheld: 'لم تُرسَل لأن المصلحة لم تقبل الفاتورة',
      },
    },
    journey: {
      label: 'مسار المستند',
      drafting: 'إعداد المسودة',
      finalIssue: 'الإصدار النهائي',
      etaValidation: 'تحقق المصلحة',
      result: 'النتيجة',
      notReached: 'لم تبدأ بعد',
      notApplicable: 'لا تنطبق',
      cancelInProgress: 'طُلب الإلغاء',
      declineInProgress: 'طُلب الاعتراض',
      cancelDeclined: 'صالحة: اعترض المشتري على الإلغاء',
      rejectionDeclined: 'صالحة من جديد: سُجّل اعتراضنا',
    },
    glance: 'في لمحة',
    actions: {
      title: 'إجراءات لدى المصلحة',
      cancelPeriod: 'مهلة الإلغاء',
      declinePeriod: 'مهلة الاعتراض',
      open: (date: string) => `متاح حتى ${date}`,
      uncertain: 'قد تكون المهلة انتهت؛ تقرر المصلحة عند الإرسال',
      closed: (date: string) => `انتهت المهلة في ${date}`,
      closedNoDate: 'انتهت المهلة',
      // G-4: «مضى ${elapsed}» gave «مضى دقيقة واحدة» for a feminine unit, where Arabic wants «مضت». The
      // rewrite is gender-safe by construction — no verb agrees with the unit, so no conditional is
      // needed and every value of `elapsed` reads correctly.
      unknown: (elapsed: string, event: string) =>
        `المهلة محدودة وتحددها المصلحة؛ تصرّف سريعًا. منذ ${event}: ${elapsed}.`,
      sinceSubmission: 'الإرسال إلى المصلحة',
      sinceIssue: 'الإصدار النهائي',
      sinceRejection: 'رفض المشتري',
      elapsed: {
        minutes: (n: number) =>
          n === 1 ? 'دقيقة واحدة' : n === 2 ? 'دقيقتان' : n <= 10 ? `${n} دقائق` : `${n} دقيقة`,
        hours: (n: number) =>
          n === 1 ? 'ساعة واحدة' : n === 2 ? 'ساعتان' : n <= 10 ? `${n} ساعات` : `${n} ساعة`,
        days: (n: number) =>
          n === 1 ? 'يوم واحد' : n === 2 ? 'يومان' : n <= 10 ? `${n} أيام` : `${n} يومًا`,
      },
      simulatorValue: 'قيمة محاكاة',
      reports: 'تُبلغ المصلحة:',
      noParameters: 'لم تُبلغ المصلحة عن مُهل لهذا النوع من المستندات.',
      noParametersForAction: 'لم تُبلغ المصلحة بمهلة تخص هذا الإجراء.',
      validFrom: 'سارية من',
      validTo: 'حتى',
      validOpen: 'دون تاريخ انتهاء',
      dates: 'تواريخ أبلغت بها المصلحة',
      dateLabels: {
        cancelRequestDate: 'طلب الإلغاء',
        cancelRequestDelayedDate: 'يسري الإلغاء ما لم يُعترض عليه حتى',
        rejectRequestDate: 'رفض المشتري',
        rejectRequestDelayedDate: 'يسري الرفض ما لم يُعترض عليه حتى',
        declineCancelRequestDate: 'اعتراض المشتري على الإلغاء',
        declineRejectRequestDate: 'اعتراضنا على الرفض',
      },
      checking: 'نتحقق من المصلحة',
      unconfirmed: 'أرسلنا الطلب ولم تؤكد المصلحة أثره بعد',
      release: 'لم يصلنا تأكيد الإلغاء — اعتبر الطلب غير قائم',
      // F-4 (R-17): we stopped treating the request as outstanding and the Authority showed the
      // document valid. Whether ETA still applies the cancellation afterwards is not ours to assert.
      // B-1 (DEC-107): «اعتبر» describes OUR treatment, so it cannot be read as sending anything.
      released: 'لم نعد نعتبر طلب الإلغاء قائمًا، وأظهرت المصلحة المستند صالحًا',
      releaseRefused: 'بقي طلب الإلغاء قائمًا: تُظهر المصلحة طلب إلغاء أو حالة غير صالحة',
      cancelRequested: 'طلب الإلغاء لدى المصلحة',
      // G-3 (F-5; plan D-3): the band carries the SAME qualifier as the timeline, decided by the one
      // predicate the server computes (`cancellationSettled`). `cancelledSettled` is said only when
      // the buyer's own period to object has certainly closed; while it is open, uncertain or unknown
      // the line says ETA's reading and that the buyer may still object — never that it is over. The
      // key is named for the state it describes, not «final», which belongs to the `eta_cancelled_final`
      // event.
      cancelledSettled: 'ألغت المصلحة هذا المستند',
      cancelledPendingObjection: 'ألغت المصلحة هذا المستند، وقد يعترض المشتري خلال مهلته',
      cancelDeclined: (date: string) =>
        `اعترض المشتري على الإلغاء في ${date}؛ بقي المستند صالحًا، ويبقى التصحيح بإشعار دائن.`,
      cancelDeclinedNoDate:
        'اعترض المشتري على الإلغاء؛ بقي المستند صالحًا، ويبقى التصحيح بإشعار دائن.',
      rejected: 'رفض المشتري هذا المستند لدى المصلحة',
      rejectionDeclined: 'اعترضنا على الرفض، وتُظهر المصلحة المستند صالحًا من جديد',
      cancelClosed: 'انتهت مهلة الإلغاء. يبقى تصحيح هذه الفاتورة بإشعار دائن.',
      declineClosed: 'انتهت مهلة الاعتراض على الرفض؛ لا يُرسل شيء.',
      frozen:
        'جمّدت المصلحة هذا المستند، فلا يقبل أي إجراء (إلغاء أو اعتراض) حتى ترفع المصلحة التجميد؛ لا يرفعه هذا البرنامج.',
      frozenWarning: 'المستند مجمّد لدى المصلحة؛ قد ترفض الطلب',
      inFlight: 'طلب آخر لهذا المستند قيد التنفيذ لدى المصلحة',
      watchEnded: (date: string) => `توقفت المتابعة التلقائية في ${date}`,
      check: 'تحقق الآن من المصلحة',
      checkRequested: 'طلبنا القراءة من المصلحة؛ ستظهر النتيجة هنا',
      cancelAction: 'اطلب إلغاء المستند لدى المصلحة',
      declineAction: 'اعترض على رفض المشتري',
      requestOf: {
        cancel: 'طلب الإلغاء',
        decline_rejection: 'الاعتراض على الرفض',
        reject: 'الرفض',
        decline_cancellation: 'الاعتراض على الإلغاء',
      },
      refusedBy: {
        eta: 'رفضته المصلحة',
        local: 'لم يُرسل',
      },
      notApplied: 'لم تُطبّق المصلحة الطلب',
      failed: 'تعذّر إرسال الطلب، ولم يصل شيء إلى المصلحة',
      outcome: {
        eta_window_closed: 'انتهت مهلة هذا الإجراء لدى المصلحة',
        eta_incorrect_state: 'رفضت المصلحة الطلب لأن حالة المستند لا تسمح به',
        eta_forbidden: 'لا يسمح حساب المنشأة لدى المصلحة بهذا الإجراء',
        document_frozen: 'جمّدت المصلحة هذا المستند',
        active_referencing_documents: 'ألغِ أولًا الإشعارات المبنية على هذه الفاتورة',
        eta_refused: 'رفضت المصلحة الطلب',
        eta_throttled: 'طلبت المصلحة التمهّل؛ لم يُرسل شيء مرتين',
        eta_auth_failed: 'رفضت المصلحة بيانات الربط',
      } as Record<string, string>,
      refusal: {
        not_cancellable: 'حالة المستند لدى المصلحة لا تسمح بهذا الإجراء الآن',
        not_rejected: 'حالة المستند لدى المصلحة لا تسمح بهذا الإجراء الآن',
        request_in_flight: 'طلب آخر لهذا المستند قيد التنفيذ لدى المصلحة',
        already_requested: 'أُرسل هذا الطلب من قبل؛ ننتظر أن تؤكد المصلحة أثره',
        already_declined: 'سبق الاعتراض مرة، ولا يتكرر',
        cancel_declined_by_receiver: 'اعترض المشتري على الإلغاء؛ يبقى التصحيح بإشعار دائن',
        // m-2: a refusal can surface as a toast with the button out of view, so it names the
        // action instead of pointing at it with a bare «هذا».
        release_not_allowed:
          'لا يصحّ اعتبار الطلب غير قائم إلا على طلب إلغاء بانتظار تأكيد المصلحة',
        not_readable: 'لا يوجد ما يُقرأ من المصلحة بعد',
      } as Record<string, string>,
      // The next step after a refusal (RB3R11-06 / W3-05): what to change and where. The codes in
      // NO_RETRY (EtaActions.tsx) also hide the action, so the band never offers a doomed retry.
      nextStep: {
        eta_forbidden:
          'الخطوة التالية: اطلب من مدير حساب المنشأة لدى المصلحة تفعيل هذا الإجراء؛ لن تنجح إعادة المحاولة بالحساب الحالي.',
        active_referencing_documents:
          'الخطوة التالية: ألغِ أولًا الإشعارات المبنية على هذه الفاتورة، ثم أعد المحاولة.',
        eta_auth_failed: 'الخطوة التالية: راجع بيانات الربط بالمصلحة، ثم أعد المحاولة.',
        document_frozen: 'الخطوة التالية: انتظر رفع المصلحة للتجميد؛ لا يمكن إجراء هذا الآن.',
      } as Record<string, string>,
      versionChanged: 'تغيّرت حالة المستند لدى المصلحة؛ راجعها ثم أعد المحاولة',
      cancelDialog: {
        title: 'طلب إلغاء المستند لدى المصلحة',
        lead: 'نرسل إلى المصلحة طلب إلغاء هذا المستند. لا يُلغى إلا إذا قبلته المصلحة، وقد يعترض المشتري خلال مهلته.',
        number: 'رقم المستند',
        buyer: 'المشتري',
        period: 'المهلة',
        reasonGroup: 'سبب الإلغاء',
        reasonBuyer: 'بيانات المشتري غير صحيحة',
        reasonDocument: 'بيانات المستند غير صحيحة',
        reasonOther: 'سبب آخر',
        reasonText: 'نص السبب كما يصل إلى المصلحة',
        reasonHelp: 'من حرف واحد إلى 500 حرف، ويُرسل كما كُتب',
        confirm: 'أرسل طلب الإلغاء',
        queued: 'دخل طلب الإلغاء طابور الإرسال؛ سيظهر رد المصلحة في هذه الصفحة',
        same: 'طلب الإلغاء هذا في طريقه بالفعل',
      },
      declineDialog: {
        title: 'الاعتراض على رفض المشتري',
        lead: 'نرسل إلى المصلحة اعتراضك على رفض المشتري. إن قبلته عاد المستند صالحًا. يكون الاعتراض مرة واحدة.',
        confirm: 'أرسل الاعتراض',
        queued: 'دخل الاعتراض طابور الإرسال؛ سيظهر رد المصلحة في هذه الصفحة',
      },
      // G-1 (R-17): the lead invites a new cancellation or a credit note, which is exactly the case
      // R-17 names — a released cancel that ETA applies after all, with a credit note issued in
      // between. So it also says what would actually happen then, and the claim is true of the code:
      // `cancelPending` (`packages/domain/src/sales/state-change.ts`) is true again as soon as ETA
      // reports `cancelRequestDate` with no decline and a status other than `cancelled` — a released
      // request is not live — and `eta-watch.ts` writes that reported date into the state, so the
      // band's «طلب الإلغاء لدى المصلحة» line and the list's pending cancellation both return.
      releaseDialog: {
        title: 'اعتبار طلب الإلغاء غير قائم',
        lead: 'سنقرأ حالة المستند من المصلحة أولًا. إذا ظهر صالحًا بلا طلب إلغاء، نعتبر الطلب غير قائم عندنا، ويمكنك بعدها طلب الإلغاء من جديد أو إنشاء إشعار الدائن. وإن أبلغت المصلحة بتاريخ طلب إلغاء بعد ذلك، عاد الطلب إلى الظهور في هذه الصفحة.',
        confirm: 'اعتبر الطلب غير قائم',
        queued: 'طُلب اعتبار الطلب غير قائم؛ ستظهر القراءة في هذه الصفحة',
      },
    },
  },
  parties: {
    newTitle: 'مشترٍ جديد',
    editTitle: 'بيانات المشتري',
    type: 'فئة المشتري',
    types: {
      B: 'منشأة في مصر',
      P: 'شخص طبيعي',
      F: 'أجنبي',
    },
    typeHints: {
      B: 'شركة مسجلة: رقم تسجيل ضريبي من 9 أرقام.',
      P: 'فرد: الرقم القومي (14 رقمًا) اختياري.',
      F: 'خارج مصر: الرقم الضريبي في بلده.',
    },
    name: 'اسم المشتري',
    email: 'بريد الفواتير',
    phone: 'هاتف التواصل',
    taxIdB: 'رقم التسجيل الضريبي',
    taxIdP: 'الرقم القومي',
    taxIdF: 'الرقم الضريبي الأجنبي',
    category: 'مجموعة العملاء',
    noCategory: 'بدون مجموعة',
    newCategory: 'مجموعة جديدة',
    categoryName: 'اسم المجموعة',
    create: 'إنشاء واختيار',
    save: 'حفظ المشتري',
    created: 'أُضيف المشتري.',
    updated: 'حُدّثت بيانات المشتري.',
  },
  catalogue: {
    pickerTitle: 'الاختيار من الكتالوج',
    pickerSearch: 'اسم الصنف أو SKU أو كود المصلحة',
    selected: (n: number) => (n === 1 ? 'صنف واحد مختار' : `${n} أصناف مختارة`),
    addSelected: (n: number) => (n === 1 ? 'إضافة صنف واحد' : `إضافة ${n} أصناف`),
    newItem: 'صنف جديد في الكتالوج',
    editTitle: 'تعديل الصنف',
    newTitle: 'صنف جديد في الكتالوج',
    nameAr: 'الاسم بالعربية',
    nameEn: 'الاسم بالإنجليزية',
    description: 'الوصف على الفاتورة',
    price: 'سعر الوحدة في الكتالوج (ج.م)',
    internalCode: 'الكود الداخلي (SKU)',
    unit: 'وحدة البيع',
    kgWarning: 'في جدول وحدات المصلحة تعني "KG" برميلًا صغيرًا. للكيلوجرام اختر KGM.',
    discount: 'الخصم الافتراضي (ج.م)',
    itemsDiscount: 'خصم الأصناف (ج.م)',
    valueDifference: 'فرق القيمة (ج.م)',
    etaCode: 'كود الصنف لدى المصلحة',
    etaCodeHint: 'ابحث في أكوادك المسجلة أو أدخل كودًا جديدًا (EGS أو GS1).',
    etaType: 'نوع الكود',
    codeSearch: 'أكوادك',
    taxes: 'الضرائب الافتراضية',
    addCustomTax: 'ضريبة خاصة بالمنشأة',
    customTaxTitle: 'ضريبة خاصة بالمنشأة',
    taxType: 'نوع الضريبة لدى المصلحة',
    taxSubtype: 'النوع الفرعي',
    rate: 'النسبة (٪)',
    taxNameAr: 'الاسم بالعربية',
    taxNameEn: 'الاسم بالإنجليزية',
    createTax: 'احفظ الضريبة',
    classification: 'التصنيف الضريبي (يُحفظ للتقارير فقط)',
    readOnlyNote: 'تُحدَّد مرة واحدة عند إنشاء الصنف.',
    taxGoodsType: 'نوع السلعة الضريبي',
    taxGoodsTypes: { general: 'عام', table: 'جدول' },
    tableGoodsType: 'نوع الجدول',
    tableGoodsTypes: {
      none: 'ليست من سلع الجدول',
      table_1: 'الجدول الأول',
      table_2: 'الجدول الثاني',
    },
    statementType: 'تصنيف الإقرار',
    statementTypes: { goods: 'منتجات', service: 'أعمال وخدمات', adjustment: 'تعديلات قيمة' },
    itemKind: 'نوع الصنف',
    itemKinds: { goods: 'سلعة', service: 'خدمة' },
    create: 'إنشاء وإضافة',
    save: 'حفظ الصنف',
    created: 'تم إنشاء الصنف.',
    updated: 'تم تحديث الصنف.',
    category: 'مجموعة الأصناف',
    empty: 'لا توجد أصناف مطابقة.',
    backToList: 'العودة إلى الكتالوج',
    linesAdded: (n: number) => (n === 1 ? 'أُضيف بند واحد.' : `أُضيفت ${n} بنود.`),
  },
  dashboard: {
    greeting: (name: string) => `أهلًا، ${name}`,
    subtitle: 'فواتيرك في لمحة.',
    recent: 'أحدث المستندات',
    viewAll: 'كل الفواتير',
    newInvoice: 'ابدأ فاتورة',
    setupTitle: 'جهّز منشأتك لإصدار الفواتير',
    setupBody: 'أكمل هذه الخطوات مرة واحدة. يُعاد التحقق من كل خطوة عند الإصدار.',
    setupDone: 'اكتمل الإعداد',
    steps: {
      rin: 'رقم التسجيل الضريبي',
      profile: 'البريد الإلكتروني والهاتف',
      branch: 'عنوان فرع الإصدار',
      activity: 'رموز نشاط المموّل',
      tax: 'ضريبة القيمة المضافة وغيرها',
      customer: 'أول مشترٍ',
      item: 'أول صنف',
    },
    stepAction: 'إعداد',
    stepDone: 'تم',
  },
  setup: {
    profileTitle: 'بيانات المنشأة',
    rin: 'رقم التسجيل الضريبي',
    email: 'بريد الفوترة',
    phone: 'هاتف الفوترة',
    save: 'احفظ البيانات',
    saved: 'تم الحفظ.',
    branchTitle: 'فرع الإصدار',
    etaBranchId: 'رقم الفرع لدى المصلحة',
    etaBranchIdHint: 'استخدم 0 للمركز الرئيسي.',
    branchName: 'اسم الفرع',
    addBranch: 'احفظ الفرع',
    activityTitle: 'رموز نشاط المموّل',
    activitySearch: 'ابحث في أكواد النشاط الرسمية',
    primary: 'رئيسي',
    makePrimary: 'اجعله الرئيسي',
    saveActivities: 'حفظ رموز النشاط',
    activityLocked: 'تُحدد أكواد النشاط مرة واحدة.',
    taxTitle: 'إضافة ضريبة',
    vatPreset: 'ضريبة القيمة المضافة 14٪ (V009)',
    currencyTitle: 'عملات المستندات',
    addCurrency: 'تفعيل العملة',
    remove: 'إيقاف الاستخدام',
  },
};
